import { ChangeDetectorRef, Component, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from 'src/app/common/services/loader.service';
import { SnapshotSharedVariablesService } from '../Services/snapshot-shared-variables.service';
import { SharedPopupService } from 'src/app/common/services/shared-popup.service';
import { SnapshotService } from '../Services/snapshot.service';
import * as _ from 'lodash';
import { UserProjectManagementService } from 'src/app/common/services/user-project-management.service';
import { saveAs } from 'file-saver';
import html2canvas from 'html2canvas';
import { Observable, Subject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { COMMON_CONSTANTS_SNAPSHOT, COMMON_CONSTANTS_SETTING, isAdTrackingStudy } from 'src/app/common/constants/common-constants';
import { AlertMessageModel, results } from 'src/app/common/models/common.model';
import { AlertMessageService } from 'src/app/common/services/alert-message.service';
@Component({
  selector: 'app-outputview',
  templateUrl: './outputview.component.html',
  styleUrls: ['./outputview.component.css']
})
export class OutputviewComponent {
  isSelectionSummary = false;
  significance: any = [];
  significanceSelectedValue = "None";
  confidenceLevel: any = [];
  confidenceLevelSelectedValue = "";
  baseLevelSelectedValue = "Answer Base";
  searchQuery: string = "";
  base: any;
  base2: any;
  existingData: any = [];
  moduleList: any = [];
  sigTypeSelected: any = '';
  weight: any = [];
  MainResult: any;
  ConfidenceLevelDropDownToggle: boolean = false;
  BaseDropDownToggle: boolean = false;
  weightDropDownToggle: boolean = false;
  displayConfidenceLevel: string = "";
  LowBase: string = '';
  insufficientBase: string = '';
  isLoadSelection: boolean = false;
  isDefaultLoad:boolean = false;
  isShareSelectionClick: boolean = false;

  loadUserDefinedSavedScenarioData: any = [];
  loadSharedWithMeSavedScenarioData: any = [];
  loadDefaultSavedScenarioData:any = [];
  selected_client: string = '';
  selected_study: string = '';
  selected_module: string = '';
  shareSelectionUserList: string[] = [];
  currentSavedScenarioData: any; //has only limted data shown in load selection popup
  selectedLoadSelectionObj: any;
  selectedEmailsToShare: string[] = [];
  deleteMessage: string = '';
  loadSelectionType: string = ''; //selection type to delete
  isShowDialog: boolean = false;
  showLoaderPopUp: boolean = false;
  loadCustomGroupUserDefinedData: any;
  loadCustomGroupSharedWithMeData: any;
  loadCustomCalculationUserDefinedData: any;
  loadCustomCalculationSharedWithMeData: any;
  isSavedScenarioSelected: boolean = false;
  selectedScenarioData: any;
  dataArray: any[] = [];
  selectionSummary: string = '';
  output_data:any;
  additionalCheckList:any;
  selectedBrandFromConfig: any = null;

  constructor(
    private router: Router,
    private Loader: LoaderService,
    private snapshotCount: SnapshotSharedVariablesService,
    public _configService: SnapshotService,
    private _configService1: SharedPopupService,
    public clientDetails: SnapshotSharedVariablesService,
    private snapshotDetails: SnapshotSharedVariablesService,
    private _loaderService: LoaderService,
    private cdr: ChangeDetectorRef,
    private _configData: SnapshotService,
    private _usermanagementService: UserProjectManagementService,
    private _alertService: AlertMessageService,
  ) {
    ;
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      this.clientDetails.clientDetails = navigation?.extras
        .state as SnapshotSharedVariablesService;
      
      this._configService.SnapshotList = navigation?.extras.state['snapList'];
    }
  }

  private subscriptions: Subscription = new Subscription();
  snapHeaderName: any;
  snapHeaderNameFun(data: any) {
    this.snapHeaderName = data;
  }
  @Input() ImageURL: string = '';
  brandLogo(eventData: { Image: string }) {
    this.ImageURL = eventData.Image;
  }
  page2Toggle: number = 1;
  TrendToggleContainer: boolean = true;
  TrendToggleOn: boolean = false;
  showSaveSelectionButton: boolean = true;
  settingOptionList = COMMON_CONSTANTS_SETTING;
  
  ngOnInit() {
    this.subscriptions.add(
      this._configData.page2ToggleSubject.subscribe((value) => {
        this.page2Toggle = value;
      })
    );
    this.subscriptions.add(
      this._configData.pageCounter.subscribe((value) => {
        this.pageCounter = value;
      })
    );

    let data1 = {
      "clientName": this.clientDetails.clientDetails.client_code,
      "snapshotName": this.clientDetails.clientDetails.study
    }
    this.selected_study = this.clientDetails.clientDetails.study;
    this.selected_client = this.clientDetails.clientDetails.client_code;
    this.showSaveSelectionButton = this._configService.outputSnapshotData?.saveselection != null ? (this._configService.outputSnapshotData?.saveselection?.find((m: any) => m.key == "Save/Load")?.value ?? false) : false;
    this.subscriptions.add(
      this._configService.getWidgetLibraryConfiguration(data1).subscribe((r: any) => {

        if (r.Data) {
          this._configService.widgetAllData = JSON.parse(r.Data);

        }
        else {
          this._configService.widgetAllData = [];
        }
        
        this._configService.snapshotProductType = 'standard';
        this._configService.setwidgetVariable(this._configService.widgetAllData);


        this.existingData = this._configService.widgetAllData;
      })
    );
  }
  selectedType: string = "";
  filteredWidgetSelection: any;
  pageCounter: number = 1;
  item: any;
  items: any;
  itemWithoutTrend: any;
  itemWithoutTrendItems: any;
  showSampleSizePop: boolean = false;

  handlemetricname(metricName: any, type: number = 0) {
    if (type == 0)
      return metricName; // No delimiter
    else if (type == 1) {
      const parts = metricName.split('|'); // for showing only the last part (without delimiter)
      return parts[1];
    }

    const parts = metricName.split('|');

    if (parts.length <= 2) {
      return metricName;
    }

    return parts.slice(-2).join('|').trim();
  }
  selectedTypeFun(data: any) {
    this.selectedType = data;
    const sectionNav = document.querySelector('app-header-section-list');
    if (sectionNav) {
      sectionNav?.classList.remove('NN');
    }
    //;
    this.filteredWidgetSelection = this.existingData.filter((item: any) => {
      //for Multiple Brands if else condition will come based on snapshotType
      return (item.snapshotType == this.selectedType && item.sections != "NA" && item.subsection == "NA")
    })



    this.moduleList = [];
    this.filteredWidgetSelection.forEach((element: any) => {
      this.moduleList.push({ name: element.sections, isSelected: false })
    });
    if (this.moduleList.length > 0)
      this.moduleList[0].isSelected = true;

  }

  //on section header click
  receivedModifiedList(data: any) {
    this.moduleList = _.cloneDeep(data);
    // this.pageCounter = 1;
    this._configData.pageCounter.next(1);
    this._configData.page2ToggleSubject.next(1);
    this.filteredWidgetSelection = this.filteredWidgetSelection;
  }
  // brandLogo(eventData: { Image: string }) {
  //   this.ImageURL = eventData.Image;
  //    ;
  // }

  handleCheckboxClick(event: MouseEvent) {
    // Check if the checkbox was clicked
    if (event.target instanceof HTMLInputElement && event.target.type === 'checkbox') {
      // If the checkbox was clicked, don't call variableExpand()
      return;
    }
  }
  toggleLeftPanel(data: boolean) {
    const leftPanel = document.querySelector('app-leftpanel-snapshot');
    if (data == true) {
      if (leftPanel) {
        leftPanel?.classList.remove('expandLeftPanel');
      }
    } else {
      if (leftPanel) {
        leftPanel?.classList.add('expandLeftPanel');
      }
    }
  }

  selectedSigType: any[] = [];
  stacticText: string = "";
  isAnswerBase: boolean = false;
  showOutput: boolean = true;
  showOutputView: boolean = false;
  outputData: any;
  exportSelected: any;
  editablePPT = false;
  staticPPT = false;
  excelExport = false;
  weightSelectedValue: any = "";

  buttonText: string = "OK";
  x: any;
  y1: any = {}; //This variable is used to store Ouput object which is used in left panel submit
  allbrands: any;
  allSigBrands: any;
  thresholdIndex: any;

  significanceVal: any[] = [];

  higherIndexValue: any;
  lowerIndexValue: any;
  indexText: any;

  resetValues() {
    this.isSigSelected = true;
    this.isIndexSelected = false;
    this.sigConBaseToggle = true;
    //reset indexing serach box
    this.searchQuery = '';
    //reseting reference Dropdown
    this.displayReference = "None";
    this.selectedReference = "None";
    //reseting AnswerBase dropdown 


    this._configService.isIndexSelected = false;//So that in chart dataLabelStyle==index should not be true;

    //reseting Total/Answer Base dropdown
    this.baseselected = "Total Base"
    this.baseLevelSelectedValue = "Total Base"
    this.base = [
      { key: "Total Base", selected: true },
      { key: "Answer Base", selected: false }
    ];
    this.base2 = [
      { key: "Total Base", selected: true }
    ];


    //reseting reference Dropdown
    this.displaySignificance = "None";
    this.displayConfidenceLevel = "90%";
    this.significanceDropdownToggle = false;
    this.ConfidenceLevelDropDownToggle = false;
    this.BaseDropDownToggle = false;
    this.weightDropDownToggle = false;
    this.selectedSignificance = "None";
    this.y1.significance = "None";
    this.y1.DefaultConfidenceLevel = "None";
    this._configService.updateSignificanceValue("None");
    this._configService.updateConfedenceValue("None");
    this.y1.SignificanceVsReference = '';
    this.y1.significanceVsBrandReference = [];
    this.displayBrand = false;
    // this.allSigBrands = this.allSigBrands.map((item: any) => {
    //   item.isSelected = false
    //   return item;
    // })



    //ConfidenceLevel----
    var ele = document.querySelector(".confidenceLeveldropdown");
    ele?.classList.add("DNN");



  }

  ShowOutput() {
    this._loaderService.showLoader();
    this.isLoadSelection = false;
    this.showSaveSelectionButton = this._configService.outputSnapshotData?.saveselection != null ? (this._configService.outputSnapshotData?.saveselection?.find((m: any) => m.key == "Save/Load")?.value ?? false) : false;
    this.y1 = this._configService.passdata;
    this.selectedBrandFromConfig = this._configService.outputSnapshotData?.selectedBrand || null;
    this.thresholdIndex = this._configService.thresholdIndex;
    this.higherIndexValue = 100 + this.thresholdIndex;
    this.lowerIndexValue = 100 - this.thresholdIndex;
    this.indexText = `Note: The indexed value greater than ${this.higherIndexValue} are denoted by green and in Red for values less than ${this.lowerIndexValue}`


    //--------Show and hide index based on threshold index value------------------
    var ele = document.querySelector(".indexArea");
    if (this.thresholdIndex > 0) {
      if (ele) { // Check if the element exists
        ele.classList.remove("DN");
      }
    }
    else {
      ele?.classList.add("DN");
    }

    //------------------------------------------------------------



    //for sig
    this.allSigBrands = _.cloneDeep(this._configService.brandData);
    this.allSigBrands = _.filter(this.allSigBrands, (item: any) => item.is_snapshot != 0);
    this.allSigBrands = this.allSigBrands.map((item: any) => {
      item.isSelected = false
      return item;
    })

    //for index
    let selectedBrandRef = this.output_data?.indexVsBrandReference[0]?.Data[0]?.Child;
    this.displayReference = selectedBrandRef?.split('|')[1].trim();
    this.allbrands = _.cloneDeep(this._configService.brandData);
    this.allbrands = _.filter(this.allbrands, (item: any) => item.is_snapshot != 0);
    this.allbrands = this.allbrands.map((item: any) => {
      item.isSelected = false
      return item;
    })
    this.allbrands.unshift({
      MetricOption: "None",
      isSelected: selectedBrandRef != "None" ? false : true
    })
    //Significane-------------
    // ;
    const SigVs = this._configService.outputSnapshotData?.sig_testing_vs;
    this.significance = Array.isArray(SigVs) ? SigVs.map((item: any) => ({ ...item })) : [];
    const index = this.significance.findIndex((item: any) => item.key === "Reference");

    if (index !== -1) {
      const Item = this.significance.splice(index, 1)[0];
      this.significance.push(Item);
    }

    if (
      isAdTrackingStudy(this.selected_study) &&
      !this.significance.some((item: any) => item.key === 'Norms')
    ) {
      this.significance.push({ key: 'Norms', value: true });
    }

    this.significance = this.significance.map((item: any) => {
      if(item.key == this.output_data?.significance && this.isSavedScenarioSelected){
      item.isSelected = true;
      }
      else{
        item.isSelected = false;
      }
      return item;
    })
    this.significanceVal = [];
    if(this.isSavedScenarioSelected){
    this.significanceVal.push({ key: "None", value: true, isSelected: (this.output_data?.significance == "None")});
    this.displaySignificance = this.output_data?.significance;
    this._configService.updateSignificanceValue(this.output_data?.significance);
    }
    else{
      this.significanceVal.push({ key: "None", value: true, isSelected: true });
    }

    if (isAdTrackingStudy(this.clientDetails.clientDetails.main_study)) {
      for (let i = 0; i < this.significance.length; i++) {
        if (this.significance[i].key == 'Norms')
          this.significanceVal.push(this.significance[i]);
      }
    }
    else {
      for (let i = 0; i < this.significance.length; i++) {
        this.significanceVal.push(this.significance[i]);
      }
    }
    if(this.isSavedScenarioSelected){
    this.selectedSignificance = this.significanceVal.find((item:any) => item.key == this.output_data?.significance);
    }


    //Confidence Level-----------------
    this.confidenceLevel = (this._configService.outputSnapshotData?.confidence_level).filter((item: any) => item.value == true);
    this.confidenceLevel.sort((a: any, b: any) => {
      // Extract the numerical value from the key
      const numA = parseFloat(a.key.replace('%', ''));
      const numB = parseFloat(b.key.replace('%', ''));

      return numA - numB; // Sort in ascending order
      // For descending order, use: return numB - numA;
    });
    this.confidenceLevel = this.confidenceLevel.map((item: any) => {
      item.isSelected = false
      return item;
    });

    if (this.confidenceLevel.length > 0) {
      this.confidenceLevel[0].isSelected = true;
      this.confidenceLevelSelectedValue = this.confidenceLevel[0].key;
    }


    // weights
    // this.weight=[
    //   {key:"Unweighted",isSelected:true},
    //   {key:"Weight1",isSelected:false},
    //   {key:"Weight2",isSelected:false},
    // ]
    this.weight = this._configService.weights;
    this.weightSelectedValue = this.weight[0].key;
    this._configService.weightSelected = this.weight[0].variable_label;

    // 

    this.selectedSigType = (this._configService.outputSnapshotData?.significance_type);
    this.stacticText = this._configService.outputSnapshotData?.static_text;
    this.isAnswerBase = this._configService.outputSnapshotData?.is_answer_base;

    //---Code to find which all exports needs to be displayed------
    this.exportSelected = this._configService.outputSnapshotData?.export_download
    for (let i = 0; i < this.exportSelected.length; i++) {
      if (this.exportSelected[i].key == "Editable PPT") {
        this.editablePPT = true;
      }
      if (this.exportSelected[i].key == "Excel Export") {
        this.excelExport = true;
      }
      if (this.exportSelected[i].key == "Non-Editable PPT") {
        this.staticPPT = true;
      }
    }


    // -----------------------------------------------------------
    this.significanceTypes = [];
    for (let i = 0; i < this.selectedSigType.length; i++) {
      this.significanceTypes.push({ id: (i + 1), selected: false, name: this.selectedSigType[i].key, value: this.selectedSigType[i].key })
    }

    let moduleAccessBasedOnRole = localStorage.getItem('role');
    if (moduleAccessBasedOnRole != null) {
      let userData = JSON.parse(atob(moduleAccessBasedOnRole));
      this._configService.userRole = userData.super_admin ? "superadmin" : "";
    }

    this._configService.setDropdownValue("userRole", this._configService.userRole)
    this.MainResult = this._configService.standardSnapOutputData;
    if (this._configService.standardSnapOutputData.length > 0) {

      // this.showOutputView = false;
      // setTimeout(() => {
      this.showOutputView = true;
      //}, 0);
    }
    else {
      //  this.showOutputView = true;
      //setTimeout(() => {
      this.showOutputView = false;
      //}, 0);
    }

    //Reseting the values
    if(!this.isSavedScenarioSelected){
    this.resetValues();
    }
    else{
      this.isSigSelected =  this.output_data.indexVsBrandReference.length <= 0 ;
      this.isIndexSelected = !this.isSigSelected; 
      var ele = document.querySelector(".confidenceLeveldropdown");
      if(this.isSigSelected){
        this.sigConBaseToggle = true;
      if (this.displaySignificance !== "None") {
  
        if (ele) { // Check if the element exists
          ele.classList.remove("DNN");
          this.displayConfidenceLevel = this.output_data.DefaultConfidenceLevel;
          this._configService.updateConfedenceValue(this.output_data.DefaultConfidenceLevel);
        }
      }
      else {
        this.displayConfidenceLevel = "90%";
        this._configService.updateConfedenceValue("None");
        ele?.classList.add("DNN");
      }
    }
    else{
      this.sigConBaseToggle = false;
      this.allbrands.find((option:any) => option.MetricOption == this.displayReference).isSelected = true;
      this._configService.setDropdownValue('selectedIndex', this.displayReference);
      this.referenceCalculation(this._configService.standardSnapOutputData,false);
    }
    this.baseselected = this.output_data.isTotalBase ? "Total Base" : "Answer Base";
    this.baseLevelSelectedValue = this.baseselected;
    this.base = [
      { key: "Total Base", selected: this.output_data.isTotalBase },
      { key: "Answer Base", selected: !this.output_data.isTotalBase }
    ];
    this.base2 = [
      { key: "Total Base", selected: this.output_data.isTotalBase }
    ];
    }

    setTimeout(() => {
      this._loaderService.hideLoader();
    }, 500);


    this.afterSubmit();


    if(this.isSigSelected){
    // add this.displaySignificance and this.baseselected in the this._configService.selectionSummaryText and its string in this._configService.selectionSummaryTextTitle
    this._configService.selectionSummaryTextTitle = this._configService.selectionSummaryTextTitle + " || Significance: " + this.displaySignificance + " || Base: " + this.baseselected + " || Weight: " + this.weightSelectedValue;
    this._configService.selectionSummaryText = this._configService.selectionSummaryText + `<span class="grey-separator"> ||  </span>` + `<span class="summary-label">Significance: </span>` + this.displaySignificance + `<span class="grey-separator"> ||  </span>` + `<span class="summary-label">Base: </span>` + this.baseselected + `<span class="grey-separator"> ||  </span>` + `<span class="summary-label">Weight: </span>` + this.weightSelectedValue;
    }
    else{
      this._configService.selectionSummaryText = this._configService.selectionSummaryText.replace("Index: </span>"+ this.displayReference, "Index: </span>" + this.displayReference);
      this._configService.selectionSummaryTextTitle = this._configService.selectionSummaryTextTitle.replace("Index: "+ this.displayReference, "Index: " + this.displayReference);
    }
    this.UpdateSelectionSummary();


    if (this.significance.length == 0) {
      const sigArea = document.querySelector('.sigArea') as HTMLElement;
      if (sigArea) {
        sigArea.style.display = 'none';
      }

      const significanceDropdown = document.querySelector('.significanceDropdown') as HTMLElement;
      if (significanceDropdown) {
        significanceDropdown.style.display = 'none';
      }

      const confidenceLeveldropdown = document.querySelector('.confidenceLeveldropdown') as HTMLElement;
      if (confidenceLeveldropdown) {
        confidenceLeveldropdown.style.display = 'none';
      }

    }


    const sigIndexObj = document.querySelector(".sigIndexArea") as HTMLElement;

    if (sigIndexObj) { // Check if the element exists
      sigIndexObj.style.display = (this.significance.length === 0 && this.thresholdIndex === 0) ? 'none' : 'flex';
    }

    const baseObj = document.querySelector(".baseDropdown") as HTMLElement;
    if (baseObj) { // Check if the element exists
      baseObj.style.marginLeft = (this.significance.length === 0 && this.thresholdIndex === 0) ? '0%' : '5.5%';
    }


  }
  
  getMonthNumber(monthAbbr:any) {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return months.indexOf(monthAbbr) + 1;
  }

  sortTrendTimeporiodData(metricData: any[]): any[] {
    // Filter leftPanelData for "Time Period" and sort by level1_sort_id
    let filteredLeftPanelData = this._configService.leftPanelData.filter((item: any) => item.Level0 === "Time Period" || item.Level1 === "Time Period");
    filteredLeftPanelData.sort((a: any, b: any) => {
      return a.level1_sort_id - b.level1_sort_id;
    });

    // Sort metricData based on the order of MetricOption in filteredLeftPanelData
    metricData.sort((a: any, b: any) => {
      const indexA = filteredLeftPanelData.findIndex((item: any) => item.MetricOption === a.lvl1Child.split("|")[1]);
      const indexB = filteredLeftPanelData.findIndex((item: any) => item.MetricOption === b.lvl1Child.split("|")[1]);
      return indexA - indexB;
    });
    metricData.sort((a:any, b:any) => {
      const [monthA, yearA] = a.lvl1Child.split("|")[1].split("_");
      const [monthB, yearB] = b.lvl1Child.split("|")[1].split("_");
    
      const dateA:any = new Date(yearA, this.getMonthNumber(monthA) - 1);
      const dateB:any = new Date(yearB, this.getMonthNumber(monthB) - 1);
    
      return dateA - dateB;
    });
    

    return metricData;
  }


  checkMetrics(metrics: string[]): number {
    let hasDelimiter = metrics.some(metric => metric.includes('|'));
    if (!hasDelimiter)
      return 0;

    let firstParts = metrics.map(metric => metric.split('|')[0]);
    let uniqueFirstParts = Array.from(new Set(firstParts));

    if (uniqueFirstParts.length === 1) {
      return 1;
    } else if (uniqueFirstParts.every(part => part[0] === uniqueFirstParts[0][0])) {
      return 2;
    } else {
      return 3;
    }
  }

  afterSubmit() {
    this.outputData = _.cloneDeep(this._configService.standardSnapOutputData);
    // no data pop-up
    if ((this.baseselected.toLowerCase() == "total base" && this.outputData.filter((a: any) => a.totalWeightedShare != null).length == 0) || (this.baseselected.toLowerCase() == "answer base" && this.outputData.filter((a: any) => a.answerWeightedShare != null).length == 0)) {
      this.showErrorPopUp = true;
      this.popUpMessage = "No data available for this selection.";
      this.buttonText = "";
    }




    let arr: any[] = [];
    let arrWithoutTrend: any[] = [];
    for (let i = 0; i < this.filteredWidgetSelection[0].widgetPageConfiguration.length; i++) {
      this.item = _.cloneDeep(this.filteredWidgetSelection[0].widgetPageConfiguration.find((config: any) => config.pageNumber === (i + 1)));
      this.itemWithoutTrend = _.cloneDeep(this.filteredWidgetSelection[0].widgetPageConfiguration.find((config: any) => config.pageNumber === (i + 1)));

      this.items = this.item.pagewidgetdetails.sort((a: any, b: any) => a.widgetNumber - b.widgetNumber);
      if (this.item) {
        this.items.forEach((item: any) => {
          
          item.metric.forEach((itemLev1: any) => {
            

            if (itemLev1.metricSelected.groups == '' && itemLev1.metricSelected.metrics.length > 0) {
              let allMetricsNull = true;
              // let x:any[]=[]
              // x=[...this.outputData,...this.outputData];

              let metrics = itemLev1.metricSelected.metrics.map((metric: any) => metric.metricName);

              let result = this.checkMetrics(metrics);




              itemLev1.metricSelected.metrics.forEach((metric: any) => {
                let outputRow: any[] = [];
                this.outputData.forEach((row: any) => {
                  if (row.rowChild == metric.metricName && row.widgetNumber == item.widgetNumber && item.widgetName == row.widgetName) {
                    outputRow.push(row);
                  }
                })
                //const outputRow = _.cloneDeep(this.outputData.find((row: any) => row.rowChild == metric.metricName && row.widgetNumber == item.widgetNumber && item.widgetName == row.widgetName));
                


                metric.metricName = this.handlemetricname(metric.metricName, result);
                
                
                metric.data = [];
                outputRow.forEach((row: any) => {
                  metric.data.push({

                    // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                    data: this._configService.weightToggle(this.baseselected, this._configService.weightSelected, row),
                    data2: this._configService.weightToggleIndex(this.baseselected, this._configService.weightSelected, row),
                    lvl1Child: row.Level1ColChild,
                    colChild: row.colChild,
                    rowChild: row.rowChild,
                    totalUnweightedBase: row.totalUnweightedBase,
                    totalUnweightedShare: row.totalUnweightedShare,
                    totalWeightedBase: row.totalWeightedBase,
                    totalWeightedShare: row.totalWeightedShare,
                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                    answerUnweightedBase: row.answerUnweightedBase,
                    answerUnweightedShare: row.answerUnweightedShare,
                    answerWeightedBase: row.answerWeightedBase,
                    answerWeightedShare: row.answerWeightedShare,
                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                    changeVsPY_Answer: row.changeVsPY_Answer,
                    changeVsPY_Total: row.changeVsPY_Total,
                    Level1ColResponseCode: row.Level1ColResponseCode,
                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                    CalculationType: row.CalculationType,
                    CalculationTypeIndex: row.CalculationTypeIndex,
                    baseValueforLSorIs: this.baseselected.toLowerCase() == "total base" ? row.totalUnweightedBase : row.answerUnweightedBase,
                    changeVsPY: this.baseselected.toLowerCase() == "total base" ? row.changeVsPY_Total : row.changeVsPY_Answer,
                    Significance_Value: this.baseselected.toLowerCase() == "total base" ? row.Significance_Total : row.Significance_Answer
                  })

                  if (this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare != null : row.totalWeightedShare !== null) {
                    allMetricsNull = false;
                  }
                })

                metric.data = this.sortTrendTimeporiodData(metric.data);
                // if (metric.data !== null) {
                //   allMetricsNull = false;
                // }


                // if (metric.data !== null) {
                //   allMetricsNull = false;
                // }
              });
              if (allMetricsNull) {
                item.metric = [];
                item.noData = true;
                item.noDataAvailble = true;
              }
              else {
                item.noDataAvailble = false;
              }
            }
            else if (itemLev1.metricSelected.groups != '' && itemLev1.metricSelected.metrics.length == 0) {
              let allMetricsNull = true;
              // let x: any[] = [];
              // x = [...this.outputData, ...this.outputData];
              const metrics = this.outputData.filter((row: any) => row.widgetNumber == item.widgetNumber && item.widgetName == row.widgetName);

              const groupedByRowChild = metrics.reduce((acc: any, obj: any) => {
                const key = obj.rowChild || 'undefined';
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});

              const result = Object.keys(groupedByRowChild).map(key => ({
                name: key,
                value: groupedByRowChild[key]
              }));

              if (result.length > 0) {
                result.forEach((metric: any, index: number) => {
                  itemLev1.metricSelected.metrics.push({
                    is_brandanalysis: 0,
                    metricName: this.handlemetricname(metric.name, 1),
                    selectorder: index + 1,
                    data: []
                  });

                  metric.value.forEach((row: any) => {
                    itemLev1.metricSelected.metrics[index].data.push({
                      // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                      data: this._configService.weightToggle(this.baseselected, this._configService.weightSelected, row),
                      data2: this._configService.weightToggleIndex(this.baseselected, this._configService.weightSelected, row),
                      lvl1Child: row.Level1ColChild,
                      colChild: row.colChild,
                      rowChild: row.rowChild,
                      totalUnweightedBase: row.totalUnweightedBase,
                      totalUnweightedShare: row.totalUnweightedShare,
                      totalWeightedBase: row.totalWeightedBase,
                      totalWeightedShare: row.totalWeightedShare,
                      totalWeightedShareIndex: row.totalWeightedShareIndex,
                      answerUnweightedBase: row.answerUnweightedBase,
                      answerUnweightedShare: row.answerUnweightedShare,
                      answerWeightedBase: row.answerWeightedBase,
                      answerWeightedShare: row.answerWeightedShare,
                      answerWeightedShareIndex: row.answerWeightedShareIndex,
                      changeVsPY_Answer: row.changeVsPY_Answer,
                      changeVsPY_Total: row.changeVsPY_Total,
                      Level1ColResponseCode: row.Level1ColResponseCode,
                      Level1NestColVariableCode: row.Level1NestColVariableCode,
                      CalculationType: row.CalculationType,
                      CalculationTypeIndex: row.CalculationTypeIndex,
                      baseValueforLSorIs: this.baseselected.toLowerCase() == "total base" ? row.totalUnweightedBase : row.answerUnweightedBase,
                      changeVsPY: this.baseselected.toLowerCase() == "total base" ? row.changeVsPY_Total : row.changeVsPY_Answer,
                      Significance_Value: this.baseselected.toLowerCase() == "total base" ? row.Significance_Total : row.Significance_Answer
                    });



                    itemLev1.metricSelected.metrics[index].data = this.sortTrendTimeporiodData(itemLev1.metricSelected.metrics[index].data);

                    if (this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare != null : row.totalWeightedShare !== null) {
                      allMetricsNull = false;
                    }
                  });
                });

                if (allMetricsNull) {
                  item.metric = [];
                  item.noData = true;
                  item.noDataAvailble = true;
                }
                else {
                  item.noDataAvailble = false;
                }
              }
            }

          })
          if (item.noDataAvailble != null && item.noDataAvailble != undefined && item.noDataAvailble == false) {
            item.widgetNotConfigured = item.metric.length > 0 ? false : true;
          } else {
            if (item.noDataAvailble == null || item.noDataAvailble == undefined) {
              item.widgetNotConfigured = item.metric.length > 0 ? false : true;
            } else {
              item.widgetNotConfigured = false;
            }
          }

        })
      }
      arr.push(this.item);

      arr.forEach(page => {
        const pageNumber = page.pageNumber;

        // Iterate over each widget detail in pageWidgetdetails
        page.pagewidgetdetails.forEach((widget: any) => {
          widget.pageNumber = pageNumber;
        });
      });


      this.itemWithoutTrend = _.cloneDeep(this.filteredWidgetSelection[0].widgetPageConfiguration.find((config: any) => config.pageNumber === (i + 1)));
      this.itemWithoutTrendItems = this.itemWithoutTrend.pagewidgetdetails.sort((a: any, b: any) => a.widgetNumber - b.widgetNumber);

      this.itemWithoutTrendItems = this.itemWithoutTrend.pagewidgetdetails.sort((a: any, b: any) => a.widgetNumber - b.widgetNumber);
      if (this.itemWithoutTrend) {
        this.itemWithoutTrendItems.forEach((item: any) => {
          
          item.metric.forEach((itemLev1: any) => {
            

            if (itemLev1.metricSelected.groups == '' && itemLev1.metricSelected.metrics.length > 0) {
              let allMetricsNull = true;
              // let x:any[]=[]
              // x=[...this.outputData,...this.outputData];
              let metrics = itemLev1.metricSelected.metrics.map((metric: any) => metric.metricName);
              let result = this.checkMetrics(metrics);

              itemLev1.metricSelected.metrics.forEach((metric: any) => {
                let outputRow: any[] = [];
                this.outputData.forEach((row: any) => {
                  if (row.rowChild == metric.metricName && row.widgetNumber == item.widgetNumber && item.widgetName == row.widgetName && row.Level1ColChild == this._configService.selectedTPforNonTrendView) {
                    outputRow.push(row);
                  }
                })
                //const outputRow = _.cloneDeep(this.outputData.find((row: any) => row.rowChild == metric.metricName && row.widgetNumber == item.widgetNumber && item.widgetName == row.widgetName));
                


                metric.metricName = this.handlemetricname(metric.metricName, result);
                
                
                metric.data = [];
                outputRow.forEach((row: any) => {
                  metric.data.push({

                    // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                    data: this._configService.weightToggle(this.baseselected, this._configService.weightSelected, row),
                    data2: this._configService.weightToggleIndex(this.baseselected, this._configService.weightSelected, row),
                    lvl1Child: row.Level1ColChild,
                    colChild: row.colChild,
                    rowChild: row.rowChild,
                    totalUnweightedBase: row.totalUnweightedBase,
                    totalUnweightedShare: row.totalUnweightedShare,
                    totalWeightedBase: row.totalWeightedBase,
                    totalWeightedShare: row.totalWeightedShare,
                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                    answerUnweightedBase: row.answerUnweightedBase,
                    answerUnweightedShare: row.answerUnweightedShare,
                    answerWeightedBase: row.answerWeightedBase,
                    answerWeightedShare: row.answerWeightedShare,
                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                    changeVsPY_Answer: row.changeVsPY_Answer,
                    changeVsPY_Total: row.changeVsPY_Total,
                    Level1ColResponseCode: row.Level1ColResponseCode,
                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                    CalculationType: row.CalculationType,
                    CalculationTypeIndex: row.CalculationTypeIndex,
                    baseValueforLSorIs: this.baseselected.toLowerCase() == "total base" ? row.totalUnweightedBase : row.answerUnweightedBase,
                    changeVsPY: this.baseselected.toLowerCase() == "total base" ? row.changeVsPY_Total : row.changeVsPY_Answer,
                    Significance_Value: this.baseselected.toLowerCase() == "total base" ? row.Significance_Total : row.Significance_Answer
                  })

                  if (this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare != null : row.totalWeightedShare !== null) {
                    allMetricsNull = false;
                  }
                })
              });
              if (allMetricsNull) {
                item.metric = [];
                item.noData = true;
                item.noDataAvailble = true;
              }
              else {
                item.noDataAvailble = false;
              }
            }
            else if (itemLev1.metricSelected.groups != '' && itemLev1.metricSelected.metrics.length == 0) {
              let allMetricsNull = true;
              // let x: any[] = [];
              // x = [...this.outputData, ...this.outputData];
              const metrics = this.outputData.filter((row: any) => row.widgetNumber == item.widgetNumber && item.widgetName == row.widgetName && row.Level1ColChild == this._configService.selectedTPforNonTrendView);

              const groupedByRowChild = metrics.reduce((acc: any, obj: any) => {
                const key = obj.rowChild || 'undefined';
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});

              const result = Object.keys(groupedByRowChild).map(key => ({
                name: key,
                value: groupedByRowChild[key]
              }));

              if (result.length > 0) {
                result.forEach((metric: any, index: number) => {
                  itemLev1.metricSelected.metrics.push({
                    is_brandanalysis: 0,
                    metricName: this.handlemetricname(metric.name, 1),
                    selectorder: index + 1,
                    data: []
                  });

                  metric.value.forEach((row: any) => {
                    itemLev1.metricSelected.metrics[index].data.push({
                      // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                      data: this._configService.weightToggle(this.baseselected, this._configService.weightSelected, row),
                      data2: this._configService.weightToggleIndex(this.baseselected, this._configService.weightSelected, row),
                      lvl1Child: row.Level1ColChild,
                      colChild: row.colChild,
                      rowChild: row.rowChild,
                      totalUnweightedBase: row.totalUnweightedBase,
                      totalUnweightedShare: row.totalUnweightedShare,
                      totalWeightedBase: row.totalWeightedBase,
                      totalWeightedShare: row.totalWeightedShare,
                      totalWeightedShareIndex: row.totalWeightedShareIndex,
                      answerUnweightedBase: row.answerUnweightedBase,
                      answerUnweightedShare: row.answerUnweightedShare,
                      answerWeightedBase: row.answerWeightedBase,
                      answerWeightedShare: row.answerWeightedShare,
                      answerWeightedShareIndex: row.answerWeightedShareIndex,
                      changeVsPY_Answer: row.changeVsPY_Answer,
                      changeVsPY_Total: row.changeVsPY_Total,
                      Level1ColResponseCode: row.Level1ColResponseCode,
                      Level1NestColVariableCode: row.Level1NestColVariableCode,
                      CalculationType: row.CalculationType,
                      CalculationTypeIndex: row.CalculationTypeIndex,
                      baseValueforLSorIs: this.baseselected.toLowerCase() == "total base" ? row.totalUnweightedBase : row.answerUnweightedBase,
                      changeVsPY: this.baseselected.toLowerCase() == "total base" ? row.changeVsPY_Total : row.changeVsPY_Answer,
                      Significance_Value: this.baseselected.toLowerCase() == "total base" ? row.Significance_Total : row.Significance_Answer
                    });

                    if (this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare != null : row.totalWeightedShare !== null) {
                      allMetricsNull = false;
                    }
                  });
                });

                if (allMetricsNull) {
                  item.metric = [];
                  item.noData = true;
                  item.noDataAvailble = true;
                }
                else {
                  item.noDataAvailble = false;
                }
              }
            }

          })
          if (item.noDataAvailble != null && item.noDataAvailble != undefined && item.noDataAvailble == false) {
            item.widgetNotConfigured = item.metric.length > 0 ? false : true;
          } else {
            if (item.noDataAvailble == null || item.noDataAvailble == undefined) {
              item.widgetNotConfigured = item.metric.length > 0 ? false : true;
            } else {
              item.widgetNotConfigured = false;
            }
          }

        })
      }
      arrWithoutTrend.push(this.itemWithoutTrend);
    }

    arrWithoutTrend.forEach(page => {
      const pageNumber = page.pageNumber;

      // Iterate over each widget detail in pageWidgetdetails
      page.pagewidgetdetails.forEach((widget: any) => {
        widget.pageNumber = pageNumber;
      });
    });

    //storing converted output to a service variable 
    this._configService.allPageOutputData = arr;
    this._configService.allPageOutputDataWithoutTrend = arrWithoutTrend;
    this._configService.showWidget1Page = false;
    this._configService.showWidget2Page = false;
    this._configService.allPageOutputDataWithoutTrend.forEach((item:any) => {
        if(item.pageNumber == 1){ 
          this._configService.showWidget1Page = item.pagewidgetdetails.filter((item1:any) => item1.widgetNotConfigured === false).length>0; 
      }
      else if(item.pageNumber == 2){
        this._configService.showWidget2Page = item.pagewidgetdetails.filter((item1:any) => item1.widgetNotConfigured === false).length>0; 
      }
    }) 

    if(!this._configService.showWidget2Page){
      this._configService.page2ToggleSubject.next(1);
      this.paginationCounterFun(1);
      this.page2Toggle = 1;
    }
    else if(!this._configService.showWidget1Page){
      this._configService.page2ToggleSubject.next(2);
      this.paginationCounterFun(2);
      this.page2Toggle = 2;
    }

    this._loaderService.hideLoader();
    // this._configService.setDropdownValue('outputArray', JSON.stringify(arr));
    // this.handleExcelExportClick()
  }

  closeSigDropdown() {
    this.sigTypeDropdown = false;
  }

  // handlemetricname(metricName: any) {
  //   const parts = metricName.split('|');

  //   if (parts.length <= 2) {
  //     return metricName;
  //   }

  //   return parts.slice(-2).join('|').trim();
  // }
  selectedStudy: any;
  handleExcelExportClick() {
    //;

    let data = this._configService.getDropdownValues();
    if (this.significanceSelectedValue != 'None') {
      data.confidenceLevel = this.confidenceLevelSelectedValue;
    }
    else {
      data.confidenceLevel = 'None';
    }
    data.custumview=false;
    data.compareacrossmultiplesection=data.selectionSummary.split('||')[0].trim().split(':').slice(1).map((part:any) => part.trim()).join(' | ');
    this.Loader.showLoader();
    this.subscriptions.add(
      this._configData
        .exportToExcel(data)
        .subscribe(
          (excelBlob: Blob) => {
            //;
            let datetimeFormat = this.getCurrentDateTime();
            let fileName =
              'Snapshot' + '_' +
              data.clientName +
              '_' +
              data.snapshotName + '_' +
              data.compareAcross + '_' +
              datetimeFormat +
              '.xlsx';
            // Trigger file download
            this.downloadFile(excelBlob, fileName);
            this.Loader.hideLoader();
            this.usageDataLog("Excel Export");
          },
          (error) => {
            console.error('Error exporting to Excel', error);
            //this.errorPopup('Something went wrong, please try again');
            this.Loader.hideLoader();
          }
        )
    );

  }

  usageDataLog(feature: string) {
    let summarytext = '';
    if (this._configService.selectionSummaryTextTitle != undefined && this._configService.selectionSummaryTextTitle != null) {
      // summarytext = this.summaryText?.nativeElement.innerText;
      summarytext = this._configService.selectionSummaryTextTitle
    }
    this._usermanagementService.UsageData(
      '3',
      this._configService.getDropdownValues().clientName,
      this._configService.getDropdownValues().studyName,
      feature,
      summarytext,
      this._configService.getDropdownValues().snapshotName
    );
  }


  getCurrentDateTime() {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    const formattedDateTime = `${year}-${month}-${day}-${hours}-${minutes}-${seconds}`;
    return formattedDateTime;
  }
  downloadFile(data: Blob, filename: string) {

    try {
      // Ensure the data is a Blob
      if (!(data instanceof Blob)) {
        throw new Error('Provided data is not a Blob.');
      }

      // Use FileSaver.js to save the file
      saveAs(data, filename);
      this.Loader.hideLoader();
    } catch (error) {
      console.error('Failed to download file:', error);
    }
  }

  significanceDropdownToggle: boolean = false;
  onSignificanceDropdown() {
    this.ConfidenceLevelDropDownToggle = false;
    this.BaseDropDownToggle = false;
    this.weightDropDownToggle = false;
    this.significanceDropdownToggle = !this.significanceDropdownToggle;
    // ;
  }

  onConfidenceLevelDropdown() {
    this.weightDropDownToggle = false;
    this.BaseDropDownToggle = false;
    this.ConfidenceLevelDropDownToggle = !this.ConfidenceLevelDropDownToggle;
  }

  onWeightDropdown() {
    this.ConfidenceLevelDropDownToggle = false;
    this.BaseDropDownToggle = false;
    this.weightDropDownToggle = !this.weightDropDownToggle;
  }

  onBaseDropdown() {
    this.ConfidenceLevelDropDownToggle = false;
    this.weightDropDownToggle = false;
    this.BaseDropDownToggle = !this.BaseDropDownToggle;
  }


  referenceDropdownToggle: boolean = false;
  onReferenceDropdown() {
    this.referenceDropdownToggle = !this.referenceDropdownToggle;
  }
  selectedSignificance: any;
  selectedReference: any;
  displaySignificance: any = "None";
  displayReference: any = "None";
  displayBrand = false;
  vsBrandArray: any[] = [];

  referenceSelected(item: any) {
    this.sortToggle = !this.sortToggle;//To reset sorting option to default;
    this.selectedReference = item;
    let oldReference= this.displayReference;
    this.displayReference = item.MetricOption;
    this._configService.setDropdownValue('selectedIndex', this.displayReference);

    // ;
    for (let i = 0; i < this.allbrands.length; i++) {
      // ;
      if (this.allbrands[i].MetricOption == item.MetricOption) {
        this.allbrands[i].isSelected = true;
      }
      else {
        this.allbrands[i].isSelected = false;

      }
    }

    this.referenceDropdownToggle = false;//Closing the referenece dropdown

    //Creating object for brand selected in reference similar as left panel submit object----------
    this.vsBrandArray = [];
    this.y1.indexVsBrandReference = [];
    this.y1.significanceVsBrandReference = [];
    this.vsBrandArray.push({
      Level0: this.selectedReference.Level1,
      Level1: this.selectedReference.Level2,
      Level2: this.selectedReference.MetricOption,
      Level3: '',
      Level4: '',
      Level5: '',
      calc_type: this.selectedReference.calculation_type,
      customGroupId: this.selectedReference.customGroupId,
      dataYearCode: this.selectedReference.dataYearCode,
      date: this.selectedReference.date,
      hasNextLevel: false,
      is_CustomGroup: this.selectedReference.is_CustomGroup,
      is_brand_analysis: this.selectedReference.is_brandanalysis,
      is_derived: this.selectedReference.is_derived_variable,
      is_dimension: this.selectedReference.is_dimension,
      is_multi_punch: this.selectedReference.is_multi_punch,
      is_time_Period_Present: this.selectedReference.is_time_Period_Present,
      kibanaFilterScript: "",
      response_code: this.selectedReference.response_code,
      sort_id: this.selectedReference.sort_id,
      variable_code: this.selectedReference.variable_code,
      variable_label: null, //No data available
      year_code: this.selectedReference.year_code,
    })
    if (this.vsBrandArray && item.MetricOption != "None") {
      this.vsBrandArray = this._configService.updatedDataForSubmit(this.vsBrandArray);
      // ;
      const x = this._configService.previewDataCreation(this.vsBrandArray);
      ;
      if (x !== undefined) {
        this.y1.indexVsBrandReference.push(x);
      }
    }
    if (item.MetricOption == "None") {
      this.getOutputData('sig', ''); // for a blank output
      this._configService.isIndexSelected = false;
      // let newArr = this._configService.standardSnapOutputData.map((item: any) => {
      //  item.CalculationType=item.CalculationType;
      // });
      // this._configService.standardSnapOutputData=newArr;
      // this.afterSubmit();
    }
    else {
      this.getOutputData('reference', '');
    }

    this._configService.selectionSummaryText = this._configService.selectionSummaryText.replace("Index: </span>"+oldReference, "Index: </span>" + this.displayReference);
    this._configService.selectionSummaryTextTitle = this._configService.selectionSummaryTextTitle.replace("Index: "+oldReference, "Index: " + this.displayReference);
    this.UpdateSelectionSummary();

  }
  sortToggle: boolean = true;//variable to make default sort
  significanceSelected1(item: any, event: any) {
    //reseting sorting condition
    if (item.key != "None") {
      this.sortToggle = !this.sortToggle;
    }

    if (this.displaySignificance == item.key) {
      this.sortToggle = !this.sortToggle;
      this.significanceDropdownToggle = false;
      this.ConfidenceLevelDropDownToggle = false;
      this.BaseDropDownToggle = false;
      this.weightDropDownToggle = false;
      event.stopPropagation();
      return;
    }
    this.y1.SignificanceVsReference = '';
    this.y1.significanceVsBrandReference = [];
    this.selectedSignificance = item;

    var ele = document.querySelector(".confidenceLeveldropdown");
    if (item.key !== "None") {

      if (ele) { // Check if the element exists
        ele.classList.remove("DNN");
      }
    }
    else {
      ele?.classList.add("DNN");
    }



    for (let i = 0; i < this.significanceVal.length; i++) {
      // ;
      if (this.significanceVal[i].key == item.key) {
        this.significanceVal[i].isSelected = true;
      }
      else {
        this.significanceVal[i].isSelected = false;

      }
    }


    if (item.key != "Reference") {
      this.significanceDropdownToggle = false;
      this.ConfidenceLevelDropDownToggle = false;
      this.BaseDropDownToggle = false;
      this.weightDropDownToggle = false;
      this.displayBrand = false;
      this.displaySignificance = item.key;
      this.significanceSelectedValue = item.key;
      this.y1.significance = item.key;
      this.brandSelection(this.allSigBrands, '');
      // Reset reference panel state
      this.selectedSigBrand = null;
      this.selectedReference = 'None';
    }
    else if (item.key == "Reference") {
      this.displayBrand = true;
      return;
    }

    this._configService.updateSignificanceValue(item.key);

    //Handling confidence level as per significance
    if (item.key == "None") {
      for (let i = 0; i < this.confidenceLevel.length; i++) {
        this.confidenceLevel[i].isSelected = false;
      }
      this.confidenceLevel[0].isSelected = true;
      this.confidenceLevelSelectedValue = this.confidenceLevel[0].key;
      this._configService.updateConfedenceValue(this.confidenceLevelSelectedValue);
    }


    for (let i = 0; i < this.confidenceLevel.length; i++) {
      if (this.confidenceLevel[i].isSelected == true) {
        this.y1.DefaultConfidenceLevel = this.confidenceLevel[i].key;
        this._configService.updateConfedenceValue(this.confidenceLevel[i].key);
      }
    }
    this._configService.setDropdownValue('SignificanceVsReference', item.key);
    //API Call
    ;



    //-----------------------------------------------------------

    if (this.y1.significance != "None") {
      this._configService.isIndexSelected = false;
      this.displayBrand = false;
      this.getOutputData('significance', '');
    }
    else {
      this.displayBrand = false;
      this.y1.confidenceLevel = 'None';
      this.getOutputData('', '');

    }
    if (this.displaySignificance != "Reference")
      this.UpdateSignificanceSummary();
  }

  isAdTrackingNormsFooter(): boolean {
    // Hide the country-norm colour legend when Significance is None.
    return isAdTrackingStudy(this.selected_study) && this.displaySignificance != 'None';
  }

  UpdateSignificanceSummary() {
    let signi = this.displaySignificance + (this.displaySignificance == "Reference" ? ": " + (this.selectedSigBrand == undefined ? "" : this.selectedSigBrand.MetricOption) : "");

    if (this._configService.selectionSummaryText.includes("Significance: ")) {
      let temp = this._configService.selectionSummaryText.split("Significance: </span>");

      if (this.displaySignificance == "None") {
        this._configService.selectionSummaryText = temp[0] + "Significance: </span>" + signi + `<span class="grey-separator"> ||  </span>` + `<span class="summary-label">Base: </span>` + this.baseselected + `<span class="grey-separator"> ||  </span>` + `<span class="summary-label">Weight: </span>` + this.weightSelectedValue;
      }
      else {
        if (temp.length > 2) {
          let tempt = temp[1]?.split("<span");
          tempt[0] = signi;
          this._configService.selectionSummaryText = temp[0] + "Significance: </span>" + tempt.join("<span") + `<span class="grey-separator"> ||  </span>` + `<span class="summary-label">Base: </span>` + this.baseselected + `<span class="grey-separator"> ||  </span>` + `<span class="summary-label">Weight: </span>` + this.weightSelectedValue;
        }
        else {
          this._configService.selectionSummaryText = temp[0] + "Significance: </span>" + signi + "<span class='grey-separator'> ||  </span>" + `<span class="summary-label">Confidence Level: </span>` + this.y1.DefaultConfidenceLevel + `<span class="grey-separator"> ||  </span>` + `<span class="summary-label">Base: </span>` + this.baseselected + `<span class="grey-separator"> ||  </span>` + `<span class="summary-label">Weight: </span>` + this.weightSelectedValue;;
        }
      }
    }
    else {
      this._configService.selectionSummaryText = this._configService.selectionSummaryText + `<span class="grey-separator"> ||  </span>` + `<span class="summary-label">Significance: </span>` + signi
      this._configService.selectionSummaryText = this._configService.selectionSummaryText + `<span class="grey-separator"> ||  </span>` + `<span class="summary-label">Confidence Level: </span>` + this.y1.DefaultConfidenceLevel
        + `<span class="grey-separator"> ||  </span>` + `<span class="summary-label">Base: </span>` + this.baseselected + `<span class="grey-separator"> ||  </span>` + `<span class="summary-label">Weight: </span>` + this.weightSelectedValue;
    }

    if (this._configService.selectionSummaryTextTitle.includes("Significance: ")) {
      let tempTitle = this._configService.selectionSummaryTextTitle.split("Significance: ");

      if (this.displaySignificance == "None") {
        this._configService.selectionSummaryTextTitle = tempTitle[0] + "Significance: " + signi + " || Base: " + this.baseselected + " || Weight: " + this.weightSelectedValue;
      } else {
        if (tempTitle.length > 2) {
          let temptTitle = tempTitle[1]?.split(" || ");
          temptTitle[0] = signi;
          this._configService.selectionSummaryTextTitle = tempTitle[0] + "Significance: " + temptTitle.join(" || ") + "|| Confidence Level: " + this.y1.DefaultConfidenceLevel + " || Base: " + this.baseselected + " || Weight: " + this.weightSelectedValue;
        } else {
          this._configService.selectionSummaryTextTitle = tempTitle[0] + "Significance: " + signi + " || Confidence Level: " + this.y1.DefaultConfidenceLevel + " || Base: " + this.baseselected + " || Weight: " + this.weightSelectedValue;
        }
      }
    } else {
      this._configService.selectionSummaryTextTitle = this._configService.selectionSummaryTextTitle + " || Significance: " + signi;
      this._configService.selectionSummaryTextTitle = this._configService.selectionSummaryTextTitle + " || Confidence Level: " + this.y1.DefaultConfidenceLevel + " || Base: " + this.baseselected + " || Weight: " + this.weightSelectedValue;
    }

    this.UpdateSelectionSummary();
  }


  UpdateSelectionSummary() {
    const infoRibbonDiv = document.querySelector(
      '.InforRibbonEntireSummary'
    ) as HTMLDivElement;
    const infoRibbonTextValuesDiv = document.querySelector(
      '.InforRibbonTextValues'
    ) as HTMLDivElement;


    if (infoRibbonDiv != null) {
      infoRibbonDiv.innerHTML = this._configService.selectionSummaryText;
      infoRibbonDiv.title = this._configService.selectionSummaryTextTitle;
    }

    if (infoRibbonTextValuesDiv != null) {
      infoRibbonTextValuesDiv.innerHTML = this._configService.selectionSummaryText;
      infoRibbonTextValuesDiv.title = this._configService.selectionSummaryTextTitle;
    }


    this._configService.setDropdownValue('selectionSummary', this._configService.selectionSummaryTextTitle);
  }

  UpdateIndexSummary() {

    let temp = this._configService.selectionSummaryText.split("Significance: </span>");
    let index = this.displayReference;

    this._configService.selectionSummaryText = temp[0] + "Index: </span>" + index + `<span class="grey-separator"> ||  </span>` + `<span class="summary-label">Base: </span>` + this.baseselected + `<span class="grey-separator"> ||  </span>` + `<span class="summary-label">Weight: </span>` + this.weightSelectedValue;

    let tempTitle = this._configService.selectionSummaryTextTitle.split("Significance: ");
    this._configService.selectionSummaryTextTitle = tempTitle[0] + "Index: " + index + " || Base: " + this.baseselected + " || Weight: " + this.weightSelectedValue;


    this.UpdateSelectionSummary();
  }

  // closeSignificanceDropdown() {
  //   this.significanceDropdownToggle = false;
  // }
  closeBaseDropdown() {
    this.BaseDropDownToggle = false;
  }
  closeWeightDropdown() {
    this.weightDropDownToggle = false;
  }
  closeReferenceDropdown() {
    this.referenceDropdownToggle = false;
  }
  onCLclick() {
    this.significanceDropdownToggle = false;
    //this.sortToggle=!this.sortToggle;
  }
  closeSignificance() {
    this.significanceDropdownToggle = false;
  }
  newData: any;
  getOutputData(type: string, isBaseType: string) {
    this._loaderService.showLoader();
    let finalLeftPanelSubmitObject = {
      previewData: this.y1.previewData,
      selectedClient: this.y1.selected_client,
      selectedStudy: this.y1.selected_study,
      significance: this.y1.significance,
      isFilteringActive: this.y1.isFilteringActive,
      DefaultConfidenceLevel: this.y1.DefaultConfidenceLevel,
      isTotalBase: this.y1.isTotalBase,
      selectedWeight: this.y1.selectedWeight,
      weightColumnName: this.y1.weightColumnName,
      isBoostFactor: this.y1.isBoostFactor,
      SignificanceVsReference: this.y1.SignificanceVsReference,
      columnLength: this.y1.columnLength,
      dataArray: this.y1.dataArray,
      isBrandAnalysis: this.y1.isBrandAnalysis,
      isAggregatedData: this.y1.isAggregatedData,
      isSemiAggregatedData: this.y1.isSemiAggregatedData,
      isRespondentLevel: this.y1.isRespondentLevel,
      aggregatedVariables: this.y1.aggregatedVariables,
      istimePeriodWave: this.y1.istimePeriodWave,
      widegtconfigdetails: this.y1.widegtconfigdetails,
      indexVsBrandReference: this.y1.indexVsBrandReference,
      significanceVsBrandReference: this.y1.significanceVsBrandReference,
      isTrend: this._configService.checkTrendEnabled(this.existingData)
    }
    this._configService.finalLeftPanelSubmitObject = finalLeftPanelSubmitObject;
    if (isBaseType == '') {
      this.subscriptions.add(
        this._configService.getOutPutData(
          this.y1.previewData,
          this.y1.selectedClient,
          this.y1.selectedStudy,
          this.y1.significance,
          this.y1.isFilteringActive,
          this.y1.DefaultConfidenceLevel,
          this.y1.isTotalBase,
          this.y1.selectedWeight,
          this.y1.weightColumnName,
          this.y1.isBoostFactor,
          this.y1.SignificanceVsReference,
          this.y1.columnLength,
          this.y1.dataArray,
          this.y1.isBrandAnalysis,
          this.y1.isAggregatedData,
          this.y1.isSemiAggregatedData,
          this.y1.isRespondentLevel,
          this.y1.aggregatedVariables,
          this.y1.istimePeriodWave,
          this.y1.widegtconfigdetails,
          this.y1.indexVsBrandReference,
          this.y1.significanceVsBrandReference,
          this._configService.checkTrendEnabled(this.existingData)
        ).subscribe((result) => {

          if (result.Data != null && result.Data != undefined && result.Data != "") {
            let opData = JSON.parse(result.Data);
            this.MainResult = opData;
            const sortedOPdata = opData.sort((a: any, b: any) => a.widgetNumber - b.widgetNumber);
            if (type == 'reference') {
              let dataForRef = _.cloneDeep(sortedOPdata.filter((item: any) =>
                this.y1.LeftPanelSelectedTimePeriod.some((period: any) => item.Level1ColChild.includes(period))
              ));
              let selectedSig = this.y1.significanceVsBrandReference.length > 0;
              this.referenceCalculation(sortedOPdata, selectedSig);
              // if (typeof window !== undefined) {
              //   (window as any)["jsonObjectForIndex"] = sortedOPdata;
              // }
            }
            //this._configService.standardSnapOutputData = sortedOPdata;
            //this.outputData = sortedOPdata;
            

            // const outputViewDiv = document.querySelector('.output-view');
            // if (outputViewDiv) {
            //   outputViewDiv?.classList.remove('DN');
            //   this.showOutput.emit();
            // }
            else if (type == 'sig') {
              let dataForRef = _.cloneDeep(sortedOPdata.filter((item: any) =>
                this.y1.LeftPanelSelectedTimePeriod.some((period: any) => item.Level1ColChild.includes(period))
              ));
              this._configService.standardSnapOutputData = sortedOPdata;
              if (typeof window !== undefined) {
                (window as any)["jsonobject"] = sortedOPdata;
              }
              this.afterSubmit();
            }
            else if (type == 'significance') {
              let dataForRef = _.cloneDeep(sortedOPdata.filter((item: any) =>
                this.y1.LeftPanelSelectedTimePeriod.some((period: any) => item.Level1ColChild.includes(period))
              ));
              this._configService.standardSnapOutputData = sortedOPdata;
              if (typeof window !== undefined) {
                (window as any)["jsonobject"] = sortedOPdata;
              }
              this.afterSubmit();
            }
            else if (type == 'weight') {
              this._configService.standardSnapOutputData = sortedOPdata;
              if (typeof window !== undefined) {
                (window as any)["jsonobject"] = sortedOPdata;
              }
              this.afterSubmit();
            }
            this._loaderService.hideLoader();

          }
          else {
            //No Output Data
            this._loaderService.hideLoader();
            
          }
        })
      );
    }
    else {
      if (this.MainResult != null && this.MainResult != undefined && this.MainResult != "") {
        let opData = this.MainResult;
        const sortedOPdata = opData.sort((a: any, b: any) => a.widgetNumber - b.widgetNumber);
        if (type == 'reference') {
          let dataForRef = sortedOPdata.filter((item: any) =>
            this.y1.LeftPanelSelectedTimePeriod.some((period: any) => item.Level1ColChild.includes(period))
          );
          let selectedSig = this.y1.significanceVsBrandReference.length > 0;
          this.referenceCalculation(sortedOPdata, selectedSig);
        }
        //this._configService.standardSnapOutputData = sortedOPdata;
        //this.outputData = sortedOPdata;
        

        // const outputViewDiv = document.querySelector('.output-view');
        // if (outputViewDiv) {
        //   outputViewDiv?.classList.remove('DN');
        //   this.showOutput.emit();
        // }
        else if (type == 'sig') {
          let dataForRef = sortedOPdata.filter((item: any) =>
            this.y1.LeftPanelSelectedTimePeriod.some((period: any) => item.Level1ColChild.includes(period))
          );
          this._configService.standardSnapOutputData = sortedOPdata;
          this.afterSubmit();
        }
        else if (type == 'significance') {
          let dataForRef = sortedOPdata.filter((item: any) =>
            this.y1.LeftPanelSelectedTimePeriod.some((period: any) => item.Level1ColChild.includes(period))
          );
          this._configService.standardSnapOutputData = sortedOPdata;
          this.afterSubmit();
        }
        else if (type == 'weight') {
          this._configService.standardSnapOutputData = sortedOPdata;
          this.afterSubmit();
        }
        this._loaderService.hideLoader();

      }
      else {
        //No Output Data
        this._loaderService.hideLoader();
      }
    }
  }


  //------------------ Reference Calculation Logic---------------
  selectedBrands: any[] = [];
  referenceBrand: string = "";

  referenceCalculation(output: any, selectedSig: boolean) {
    this.referenceBrand = "";
    this.selectedBrands = [];

    this.selectedBrands = this.y1.LeftPanelSelectedBrand;
    if (selectedSig) {
      this._configService.isIndexSelected = false;
      for (let i = 0; i < this.allSigBrands.length; i++) {
        if (this.allSigBrands[i].isSelected == true) {
          this.referenceBrand = this.allSigBrands[i].MetricOption;
        }
      }
    }
    else {
      this._configService.isIndexSelected = true;
      for (let i = 0; i < this.allbrands.length; i++) {
        if (this.allbrands[i].isSelected == true) {
          this.referenceBrand = this.allbrands[i].MetricOption;
        }
      }
    }

    // Find the reference brand's data for each metric
    let referenceDataMap: any = {};
    let count = 0;
    output.forEach((item: any) => {
      if (item.colChild.includes(this.referenceBrand)) {
        const key = `${item.rowChild}_${item.rowVariableCode}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
        count++;
        referenceDataMap[key] = this.baseselected.toLowerCase() !== "total base" ? item.answerWeightedShare : item.totalWeightedShare;
      }
    });
    //adding NA to reference data for 0 or null value
    Object.keys(referenceDataMap).forEach(key => {
      if (referenceDataMap[key] === null || referenceDataMap[key] === 0) {
        referenceDataMap[key] = "NA";
      }
    });
    // ;

    // Create a new array with the divided data
    let newArr = output.map((item: any) => {
      // Construct the key from rowVariableCode and widgetName
      if (item.widgetName == "Awarenesss") {
        let x = 1;
      }
      const key = `${item.rowChild}_${item.rowVariableCode}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
      const referenceValue = referenceDataMap[key];

      if (referenceValue !== undefined) {
        return {
          ...item,
          // numTotal: item.totalWeightedShare,
          // deno: referenceValue,
          totalWeightedShareIndex: referenceValue === "NA"
            ? null
            : this.baseselected.toLowerCase() == "total base"
              ? (item.totalWeightedShare / referenceValue) * 100
              : item.totalWeightedShare,
          // numAnswer: item.answerWeightedShare,
          answerWeightedShareIndex: referenceValue === "NA"
            ? null
            : this.baseselected.toLowerCase() == "answer base"
              ? (item.answerWeightedShare / referenceValue) * 100
              : item.answerWeightedShare,
          CalculationTypeIndex: "index"
        };
      }
      return item;
    });


    let updatedSelecetedBrandData = newArr.filter((item: any) => this.selectedBrands.some((brand: any) => item.colChild.includes(brand)));
    this._configService.standardSnapOutputData = updatedSelecetedBrandData;
    this._configService.referenceData = updatedSelecetedBrandData;

    if (typeof window !== undefined) {
      (window as any)["jsonObjectForIndex"] = updatedSelecetedBrandData;
    }

    this.afterSubmit();

  }
  //--------------------------------------------------------------

  selectedSigBrand: any;

  brandSelection(allBrands: any, brand: any) {
    if (brand == '') {
      for (let i = 0; i < allBrands.length; i++) {
        allBrands[i].isSelected = false;
      }
    }
    else {
      for (let i = 0; i < allBrands.length; i++) {
        // ;
        if (allBrands[i].MetricOption == brand.MetricOption) {
          allBrands[i].isSelected = true;
        }
        else {
          allBrands[i].isSelected = false;
        }
      }
    }
  }
  brandSig(brand: any, event: Event) {

    this.displaySignificance = this.selectedSignificance.key;
    this.significanceSelectedValue = this.selectedSignificance.key;
    this.y1.significance = this.selectedSignificance.key;
    this._configService.updateSignificanceValue(this.significanceSelectedValue);
    this._configService.isIndexSelected = false;
    for (let i = 0; i < this.confidenceLevel.length; i++) {
      if (this.confidenceLevel[i].isSelected == true) {
        this.y1.DefaultConfidenceLevel = this.confidenceLevel[i].key;
        this._configService.updateConfedenceValue(this.confidenceLevel[i].key);
      }
    }
    this._configService.setDropdownValue('SignificanceVsReference', this.significanceSelectedValue);

    this.selectedSigBrand = brand;
    this.brandSelection(this.allSigBrands, brand);

    this.onSignificanceDropdown();
    event.stopPropagation();

    //Creating object for brand selected in reference similar as left panel submit object----------
    this.vsBrandArray = [];
    this.y1.indexVsBrandReference = [];
    this.y1.significanceVsBrandReference = [];
    this.y1.SignificanceVsReference = "Reference";
    this.vsBrandArray.push({
      Level0: this.selectedSigBrand.Level1,
      Level1: this.selectedSigBrand.Level2,
      Level2: this.selectedSigBrand.MetricOption,
      Level3: '',
      Level4: '',
      Level5: '',
      calc_type: this.selectedSigBrand.calculation_type,
      customGroupId: this.selectedSigBrand.customGroupId,
      dataYearCode: this.selectedSigBrand.dataYearCode,
      date: this.selectedSigBrand.date,
      hasNextLevel: false,
      is_CustomGroup: this.selectedSigBrand.is_CustomGroup,
      is_brand_analysis: this.selectedSigBrand.is_brandanalysis,
      is_derived: this.selectedSigBrand.is_derived_variable,
      is_dimension: this.selectedSigBrand.is_dimension,
      is_multi_punch: this.selectedSigBrand.is_multi_punch,
      is_time_Period_Present: this.selectedSigBrand.is_time_Period_Present,
      kibanaFilterScript: "",
      response_code: this.selectedSigBrand.response_code,
      sort_id: this.selectedSigBrand.sort_id,
      variable_code: this.selectedSigBrand.variable_code,
      variable_label: null, //No data available
      year_code: this.selectedSigBrand.year_code,
    })
    if (this.vsBrandArray) {
      this.vsBrandArray = this._configService.updatedDataForSubmit(this.vsBrandArray);
      // ;
      const x = this._configService.previewDataCreation(this.vsBrandArray);
      ;
      if (x !== undefined) {
        this.y1.significanceVsBrandReference.push(x);
      }
    }
    this.getOutputData('reference', '');

    this.UpdateSignificanceSummary();
  }
  significanceTypes: any[] = [];
  // significanceTypes = [
  //   { id: 1, selected: false, name: 'Z Test', value: 'zTest' },
  //   { id: 2, selected: false, name: 'Test 2', value: 'test2' },
  //   { id: 3, selected: false, name: 'Test 3', value: 'test3' },
  // ];

  sigTypeDropdown = false;
  onSigType(event: Event) {
    this.sigTypeDropdown = !this.sigTypeDropdown;
    event.stopPropagation();
  }
  onSigTypeClick(type: any, event: Event) {

    this._configService.setDropdownValue('significance', type.name);
    for (let i = 0; i < this.significanceTypes.length; i++) {
      if (this.significanceTypes[i] == type) {
        this.significanceTypes[i].selected = true;
      }
      else {
        this.significanceTypes[i].selected = false;
      }
    }
    event.stopPropagation();
    ;
  }


  selectionSummaryBlock(): void {
    this.isSelectionSummary = !this.isSelectionSummary;
    const infoRibbonDiv = document.querySelector('.InfoRibbonTextCompleteSummary') as HTMLDivElement;
    const infoRibbonDiv1 = document.querySelector('.InfoRibbonText') as HTMLDivElement;

    if (this.isSelectionSummary) {
      if (infoRibbonDiv1 != null) {
        infoRibbonDiv1.classList.add('DN');
      }
      if (infoRibbonDiv != null) {
        infoRibbonDiv.classList.remove('DN');
      }
    }
    else {
      if (infoRibbonDiv1 != null) {
        infoRibbonDiv1.classList.remove('DN');
      }
      if (infoRibbonDiv != null) {
        infoRibbonDiv.classList.add('DN');
      }
    }

    // if (infoRibbonDiv != null) {
    //   infoRibbonDiv.innerHTML = this._configService.selectionSummaryText;
    //   infoRibbonDiv.title = this._configService.selectionSummaryTextTitle;
    // }

    // if (infoRibbonDiv1 != null) {
    //   infoRibbonDiv1.innerHTML = this._configService.selectionSummaryText;
    //   infoRibbonDiv1.title = this._configService.selectionSummaryTextTitle;
    // }
  }

  closeSelectionSummary() {
    const infoRibbonDiv = document.querySelector('.InfoRibbonTextCompleteSummary') as HTMLDivElement;
    const infoRibbonDiv1 = document.querySelector('.InfoRibbonText') as HTMLDivElement;
    if (infoRibbonDiv1 != null) {
      infoRibbonDiv1.classList.remove('DN');
    }
    if (infoRibbonDiv != null) {
      infoRibbonDiv.classList.add('DN');
    }
  }


  significanceSelected(event: any) {

    this.y1.significance = event.target.value;
    // ;
    this._configService.setDropdownValue('SignificanceVsReference', event.target.value);
    this.significance.forEach((p: any) => {
      if (p.value == event.target.value) {
        p.selected = true;
      }
      else {
        p.selected = false;
      }
    });
    //this.dropdown.nativeElement.selectedIndex = 0;






  }

  confidenceLevelSelected(event: any) {
    this.displayConfidenceLevel = event.target.textContent;
    this._configService.setDropdownValue('confidenceLevel', event.target.textContent);
    this.confidenceLevel.forEach((p: any) => {
      if (p.key == event.target.textContent) {
        p.selected = true;
        p.isSelected = true;
      } else {
        p.selected = false;
        p.isSelected = false;
      }
    });
    //this.dropdown.nativeElement.selectedIndex = 0;
    this.y1.DefaultConfidenceLevel = event.target.textContent;
    this._configService.updateConfedenceValue(event.target.textContent);
    for (let i = 0; i < this.confidenceLevel.length; i++) {
      if (this.significanceVal[i].isSelected == true) {
        this.y1.significance = this.significanceVal[i].key;
      }
    }
    this._configService.setDropdownValue('confidenceLevel', event.target.textContent);
    //API Call

    this.getOutputData('confidence', '');


    // update the summary text
    if (this._configService.selectionSummaryText.includes("Confidence Level:")) {
      let temp = this._configService.selectionSummaryText.split("Confidence Level: </span>");

      let temp1 = temp[1]?.split("%");
      temp1[0] = this.y1.DefaultConfidenceLevel.replace("%", "");
      this._configService.selectionSummaryText = temp[0] + "Confidence Level: </span>" + temp1.join("%");

      let tempTitle = this._configService.selectionSummaryTextTitle.split("Confidence Level: ");

      let tempTitle1 = tempTitle[1]?.split("%");
      tempTitle1[0] = this.y1.DefaultConfidenceLevel.replace("%", "");
      this._configService.selectionSummaryTextTitle = tempTitle[0] + "Confidence Level: " + tempTitle1.join("%");

    }
    this.UpdateSelectionSummary();
    this.ConfidenceLevelDropDownToggle = false;
  }

  weightSelected(event: any) {
    let weight_variable = this.weight.find((w: any) => w.key == event.target.textContent);
    this._configService.weightSelected = weight_variable.variable_code == "" ? "Unweighted" : weight_variable.variable_code;
    this.y1.selectedWeight = weight_variable.variable_code == "" ? "Unweighted" : weight_variable.variable_code;
    this.weightSelectedValue = event.target.textContent;
   
    this.weightDropDownToggle = false;
    this.UpdateWeightSummary();
    if (this._configService.isIndexSelected) { this.getOutputData('reference', '') } else { this.getOutputData('weight', ''); }
    this.showOutput = false;
    setTimeout(() => {
      this.showOutput = true;
    }, 100)
  }


  UpdateWeightSummary() {
    // update the summary text and the title for this.baseSelected
    if (this._configService.selectionSummaryText.includes("Weight: ")) {
      let temp = this._configService.selectionSummaryText.split("Weight: </span>");

      let temp1 = temp[1]?.split(" Weight");
      temp1[0] = this.weightSelectedValue;
      this._configService.selectionSummaryText = temp[0] + "Weight: </span>" + temp1[0];

      let tempTitle = this._configService.selectionSummaryTextTitle.split("Weight: ");

      let tempTitle1 = tempTitle[1]?.split(" Weight");
      tempTitle1[0] = this.weightSelectedValue;
      this._configService.selectionSummaryTextTitle = tempTitle[0] + "Weight: " + tempTitle1[0];
    }

    this.UpdateSelectionSummary();

  }

  closeDropdown() {
    this.showContainer = false;
  }

  baseselected: any = "Total Base";
  trackByKey(_index: number, item: any): any {
    return item.key;
  }

  baseSelected(event: any) {
    this.sortToggle = !this.sortToggle;//reseting sorting dropdown value to default
    this._configService.setDropdownValue('baseType', event.target.textContent);
    this.y1.isTotalBase = event.target.textContent != "Answer Base" ;
    this.base.forEach((p: any) => {
      if (p.key == event.target.textContent) {
        p.selected = true;
        this.baseselected = p.key;
        // this.afterSubmit();
        if (this.isIndexSelected && this.displayReference != 'None') {
          this.getOutputData('reference', 'baseType');
        }
        else if (this.isIndexSelected && this.displayReference == "None") {
          this.getOutputData('sig', 'baseType');
        }
        else if (this.isSigSelected) {
          this.getOutputData('sig', 'baseType')
        }
        //  this.showOutput = false;
        //  setTimeout(() => {
        this.showOutput = true;
        // }, 100);
      }
      else {
        p.selected = false;
      }
    });
    

    // ;
    //this.dropdown.nativeElement.selectedIndex = 0;

    this.UpdateBaseSummary();
    this.BaseDropDownToggle = false;
  }
  base2Selected(event: any) {
    this.sortToggle = !this.sortToggle;//reseting sorting dropdown value to default

    this._configService.setDropdownValue('baseType', event.target.textContent);
    this.base2.forEach((p: any) => {
      if (p.value == event.target.textContent) {
        p.selected = true;
        this.baseselected = p.key;
        this.afterSubmit();
        if (this.isIndexSelected) {
          this.getOutputData('reference', 'baseType');
        }
        else if (this.isSigSelected) {
          this.getOutputData('sig', 'baseType')
        }
        // this.showOutput = false;
        // setTimeout(() => {
        this.showOutput = true;
        //  }, 100);
      }
      else {
        p.selected = false;
      }
    });
    //this.dropdown.nativeElement.selectedIndex = 0;

    this.UpdateBaseSummary();
    this.BaseDropDownToggle = false;
  }


  UpdateBaseSummary() {
    // update the summary text and the title for this.baseSelected
    if (this._configService.selectionSummaryText.includes("Base: ")) {
      let temp = this._configService.selectionSummaryText.split("Base: </span>");

      let temp1 = temp[1]?.split(" Base");
      temp1[0] = this.baseselected;
      this._configService.selectionSummaryText = temp[0] + "Base: </span>" + temp1[0] + `<span class="grey-separator"> ||  </span>` + `<span class="summary-label">Weight: </span>` + this.weightSelectedValue;

      let tempTitle = this._configService.selectionSummaryTextTitle.split("Base: ");

      let tempTitle1 = tempTitle[1]?.split(" Base");
      tempTitle1[0] = this.baseselected;
      this._configService.selectionSummaryTextTitle = tempTitle[0] + "Base: " + tempTitle1[0] + " || Weight: " + this.weightSelectedValue;;
    }

    this.UpdateSelectionSummary();

  }

  isSigSelected: any;  // Initially Sig div is selected
  isIndexSelected: any; // Initially Index div is not selected

  // select(target: string) {
  //    ;
  //   if (target === 'sig') {
  //     this.isSigSelected = true;
  //     this.isIndexSelected = false;
  //   } else if (target === 'index') {
  //     this.isSigSelected = false;
  //     this.isIndexSelected = true;
  //   }
  // }

  sigConBaseToggle = true;
  select(block: string, event: Event) {
    // ;
    //this.isSigSelected = !this.isSigSelected;
    // if (block == this.sigTypeSelected) {
    //   return;
    // }
    this.sigTypeSelected = block;
    if (block == 'sig') {
      //reset indexing serach box
      this.searchQuery = '';
      //reseting completing indexing code once clicked on sig after index

      this.referenceDropdownToggle = false;
      this.BaseDropDownToggle = false;
      this.weightDropDownToggle = false;
      this.y1 = this._configService.passdata;
      this.y1.indexVsBrandReference = [];
      this.y1.significanceVsBrandReference = [];
      this._configService.isIndexSelected = false;//So that in chart dataLabelStyle==index should not be true;
      this.displayReference = "None";
      for (let i = 0; i < this.allbrands.length; i++) {
        this.allbrands[i].isSelected = false;
      }
      this.selectedReference = "None";

      for (let i = 0; i < this.confidenceLevel.length; i++) {
        this.confidenceLevel[i].isSelected = false;
      }
      this.confidenceLevel[0].isSelected = true;
      this.y1.DefaultConfidenceLevel = this.confidenceLevel[0].key;

      this._configService.setDropdownValue('significance', "Z-test");

      this.getOutputData('sig', '');




      this.isSigSelected = true;
      this.isIndexSelected = false;
      this.sigTypeDropdown = true;
      this.sigConBaseToggle = true;


      //updating selection summary
      let temp = this._configService.selectionSummaryText.split(`<span class="summary-label">Index: </span>`);
      this._configService.selectionSummaryText = temp[0];

      let tempTitle = this._configService.selectionSummaryTextTitle.split("Index: ");
      this._configService.selectionSummaryTextTitle = tempTitle[0];
      this._configService.selectionSummaryTextTitle = this._configService.selectionSummaryTextTitle + "Significance: " + this.displaySignificance + " || Base: " + this.baseselected;
      this._configService.selectionSummaryText = this._configService.selectionSummaryText + `<span class="summary-label">Significance: </span>` + this.displaySignificance + `<span class="grey-separator"> ||  </span>` + `<span class="summary-label">Base: </span>` + this.baseselected;

      this.UpdateSignificanceSummary();

    }
    else if (block == 'index') {
      //To reset significance
      this.displaySignificance = "None";
      this.significanceDropdownToggle = false;
      this.ConfidenceLevelDropDownToggle = false;
      this.BaseDropDownToggle = false;
      this.weightDropDownToggle = false;
      this.selectedSignificance = "None";
      this.y1.significance = "None";
      this.y1.DefaultConfidenceLevel = "None";
      this._configService.updateSignificanceValue("None");
      this._configService.updateConfedenceValue("None");
      this.y1.SignificanceVsReference = '';
      this.y1.significanceVsBrandReference = [];
      this.displayBrand = false;
      this.allSigBrands = this.allSigBrands.map((item: any) => {
        item.isSelected = false
        return item;
      });
      this.allbrands=this.allbrands.map((item:any)=>{
        item.isSelected=false;
        if(item.MetricOption=="None"){
          item.isSelected=true
        }
        return item;
      })


      //this._configService.setDropdownValue('baseType', "Total Base");
      this._configService.setDropdownValue('significance', "None");
      this._configService.setDropdownValue('SignificanceVsReference', "None");
      this.isIndexSelected = true;
      this.isSigSelected = false;
      this.sigTypeDropdown = false;
      this.sigConBaseToggle = false;

      this.UpdateIndexSummary();
    }
    event.stopPropagation();
  }
  paginationCounterFun(pageNum: number) {
    // this.pageCounter = pageNum;
    this._configData.pageCounter.next(pageNum);
    
    ;
  }

  onCloseIconClick(closePopUp: any): void {
    if (closePopUp == 'false') {
      // this.errorheaderTitle = '';

      this.popUpTitle = "";
      this.showsamplesizepopup = false;
      this.showErrorPopUp = false;
      this.isLoadSelection = false;
      this.usageDataLog("Sample Size Pop up");

      if (this.popUpMessage == "Record already exists") {
        this.saveSelection();
      }
    }
    else if(closePopUp?.isLoadClickOutput == false){
      this.isLoadSelection = false;
    }
  }

  searchBoxClick(event: Event) {
    event.stopPropagation();
  }

  //samplesize
  showsamplesizepopup: boolean = false;
  OutputdataObject: any;
  isSampleSize: boolean = false;
  opobject: any = {
    Column: [], Row: []
  }



  showSampleSizePopup() {
    this.opobject = {
      Column: [], Row: []
    }
    
    // let column = {
    //   Data: [{
    //     CalculationType: "share",
    //     Child: "Month|Jan_2022",
    //     NestedArray: [],
    //     customCalculationId: null,
    //     customGroupId: null,
    //     isCustomCalculation: false,
    //     isCustomGroup: false,
    //     isDerived: false,
    //     responsecode: "1 2022",
    //     variablecode:
    //       "Month_code"
    //   },{
    //     CalculationType: "share",
    //     Child: "Month|Jan_2022",
    //     NestedArray: [],
    //     customCalculationId: null,
    //     customGroupId: null,
    //     isCustomCalculation: false,
    //     isCustomGroup: false,
    //     isDerived: false,
    //     responsecode: "1 2022",
    //     variablecode:
    //       "Month_code"
    //   },{
    //     CalculationType: "share",
    //     Child: "Month|Jan_2022",
    //     NestedArray: [],
    //     customCalculationId: null,
    //     customGroupId: null,
    //     isCustomCalculation: false,
    //     isCustomGroup: false,
    //     isDerived: false,
    //     responsecode: "1 2022",
    //     variablecode:
    //       "Month_code"
    //   },{
    //     CalculationType: "share",
    //     Child: "Month|Jan_2022",
    //     NestedArray: [],
    //     customCalculationId: null,
    //     customGroupId: null,
    //     isCustomCalculation: false,
    //     isCustomGroup: false,
    //     isDerived: false,
    //     responsecode: "1 2022",
    //     variablecode:
    //       "Month_code"
    //   },{
    //     CalculationType: "share",
    //     Child: "Month|Jan_2022",
    //     NestedArray: [],
    //     customCalculationId: null,
    //     customGroupId: null,
    //     isCustomCalculation: false,
    //     isCustomGroup: false,
    //     isDerived: false,
    //     responsecode: "1 2022",
    //     variablecode:
    //       "Month_code"
    //   },{
    //     CalculationType: "share",
    //     Child: "Month|Jan_2022",
    //     NestedArray: [],
    //     customCalculationId: null,
    //     customGroupId: null,
    //     isCustomCalculation: false,
    //     isCustomGroup: false,
    //     isDerived: false,
    //     responsecode: "1 2022",
    //     variablecode:
    //       "Month_code"
    //   }],
    //   Parent: "Month",
    //   customCalculationId: null,
    //   isCustomCalculation: false,
    //   isCustomGroup: false,
    // }

    this.TrendToggleContainer = true;
    this.TrendToggleOn = false;

    let TrendSelectedWidgets =
      this._configService.allPageOutputDataWithoutTrend[
        this.pageCounter - 1
      ].pagewidgetdetails
        .filter((x: any) => x.trend === true)
        .map((x: any) => x.widgetName);

    if (
      TrendSelectedWidgets.length ==
      this._configService.allPageOutputDataWithoutTrend[this.pageCounter - 1]
        .pagewidgetdetails.length
    ) {
      this.TrendToggleContainer = false;
    }

    if (!this.TrendToggleContainer) {
      this.TrendToggleOn = true;
    }

    let pagedetails = _.cloneDeep(
      this.outputData.filter((i: any) => i.pageNumber === this.pageCounter)
    );
    // let uniqueWidgetNames = [...new Set(this.outputData.filter((i:any)=>i.pageNumber===this.pageCounter).map((item:any) => item.widgetName))];
    let uniqueObjects = [
      ...new Map(
        this.outputData
          .filter((i: any) => i.pageNumber === this.pageCounter)
          .map((item: any) => [item.widgetName, item])
      ).values()
    ];
    //fix below code
    uniqueObjects.forEach((i: any) => {
      let nestedArray1 = pagedetails
        .filter(
          (p: any) =>
            p.widgetName == i.widgetName && i.widgetNumber == p.widgetNumber
        )
        .map((p: any) => {
          return {
            CalculationType: p.CalculationType,
            Child: p.rowChild,
            Level1ColChild: p.Level1ColChild,
            NestedArray: [],
            customCalculationId: p.customCalculationId || null,
            customGroupId: p.customGroupId || null,
            isCustomCalculation: p.isCustomCalculation || false,
            isCustomGroup: p.isCustomGroup || false,
            isDerived: p.isDerived || false,
            responsecode: p.rowResponseCode.toString(),
            variablecode: p.rowVariableCode,
            unweightedBase:
              this.baseselected.toLowerCase() == 'total base'
                ? p.totalUnweightedBase
                : p.answerUnweightedBase,
            weightedBase:
              this.baseselected.toLowerCase() == 'total base'
                ? p.totalWeightedBase
                : p.answerWeightedBase,
            trend:
              TrendSelectedWidgets.indexOf(p.widgetName) > -1 ? true : false,
          };
        });
      
      
      this.opobject.Row.push({
        Data: [{
          CalculationType: i.CalculationType || "share",
          Child: i.widgetName,
          Level1ColChild: i.Level1ColChild,
          NestedArray: nestedArray1,
          customCalculationId: i.customCalculationId || null,
          customGroupId: i.customGroupId || null,
          isCustomCalculation: i.isCustomCalculation || false,
          isCustomGroup: i.isCustomGroup || false,
          isDerived: i.isDerived || false,
          responsecode: "1",
          variablecode: "MO_MOb_2b_DAYPART"
        }
        ],
        Data1: [{ NestedArray: [] }],
        Parent: i.colChild,
        customCalculationId: i.customCalculationId || null,
        customGroupId: i.customGroupId || null,
        isCustomCalculation: i.isCustomCalculation || false,
        isCustomGroup: i.isCustomGroup || false
      })
    })

    let uniqueColObjects = Object.values(this.outputData.reduce((acc: any, obj: any) => {
      acc[obj.Level1ColChild] = obj;
      return acc;
    }, {}));



    // Sort the unique objects based on Level1ColResponseCode
    uniqueColObjects.sort((a: any, b: any) => {
      const aCode = this.parseResponseCode(a.Level1ColResponseCode);
      const bCode = this.parseResponseCode(b.Level1ColResponseCode);

      // Compare year first, then number if years are equal
      if (aCode.year !== bCode.year) {
        return aCode.year - bCode.year;
      }
      return aCode.num - bCode.num;
    });

    uniqueColObjects.forEach((i: any) => {
      let col = {
        Data: [{
          CalculationType: i.CalculationType,
          Child: i.Level1ColChild,
          NestedArray: [],
          customCalculationId: null,
          customGroupId: null,
          isCustomCalculation: false,
          isCustomGroup: false,
          isDerived: false,
          responsecode: i.Level1ColResponseCode,
          variablecode: i.Level1NestColVariableCode
        }],
        Parent: "Month",
        customCalculationId: null,
        isCustomCalculation: false,
        isCustomGroup: false
      }
      if (!this.opobject.Column.includes(col)) {
        this.opobject.Column.push(col);
      }
    })


    //     Level1ColChild
    // : 
    // "Month|May_2023"
    // Level1ColResponseCode
    // : 
    // "5 2023"
    // Level1NestColVariableCode
    // : 
    // "Month_code"



    this.showsamplesizepopup = true;
    this.OutputdataObject = this.opobject;
    this.isSampleSize = true;

    this.showSampleSizePop = false;
    setTimeout(() => {
      this.showSampleSizePop = true;
    }, 50);
  }

  showContainer: boolean = false;
  toggleContainer() {
    this.showContainer = !this.showContainer;
    this.closeSelectionSummary();
  }

  parseResponseCode(code: any) {
    const [num, year] = code.split(' ');
    return { num: parseInt(num, 10), year: parseInt(year, 10) };
  };

  @HostListener('document:click', ['$event'])
  // onDocumentClick(event: Event): void {
  //   //Check if the click event occurred outside the <div> block.
  //   //document.addEventListener('mousemove', () => this._authenticateService.resetSessionTimeoutTimer());
  //  document.addEventListener('keydown', () => this._authenticateService.resetSessionTimeoutTimer());
  //   if (this.showContainer == true) {
  //if (!this.isClickInside(event, '.showPanel')) {
  //  this.showContainer = false;
  //}
  //   }

  //}

  // private isClickInside(event: Event, className: string): boolean {
  //   const elements = document.querySelectorAll(className);
  //   for (let i = 0; i < elements.length; i++) {
  //     const container = elements[i];
  //     if (container.contains(event.target as Node)) {
  //       return true;
  //     }
  //   }
  //   return false;
  // }

  errorheaderTitle: any;
  popUpTitle: any;
  popUpMessage: any = "";
  showErrorPopUp: boolean = false;
  editablePPTClicked() {
    this._loaderService.showLoader()
    if(this._configService.showWidget1Page && this._configService.showWidget2Page){
    this._configService.setDropdownValue('outputArray', JSON.stringify(this._configService.allPageOutputDataWithoutTrend));
    }
    else if(this._configService.showWidget2Page){
      this._configService.setDropdownValue('outputArray', JSON.stringify([this._configService.allPageOutputDataWithoutTrend[1]]));
    }
    else{
      this._configService.setDropdownValue('outputArray', JSON.stringify([this._configService.allPageOutputDataWithoutTrend[0]]));
    }
    this._configService.setDropdownValue('outputTrendArray', JSON.stringify(this._configService.allPageOutputData));
    this._configService.setDropdownValue('product', 'standard');
    this._configService.getDropdownValues().staticText = this._configService.staticText;
    let data = _.cloneDeep(this._configService.getDropdownValues());
    if (this.significanceSelectedValue != 'None') {
      data.confidenceLevel = this.confidenceLevelSelectedValue;
    }
    else {
      data.confidenceLevel = 'None';
    }
    // let data1=_.cloneDeep(this._configService.getDropdownValues());
    this.subscriptions.add(
      this._configService.callPptExport("",data).subscribe(
        (pptBlob: Blob) => {
          // Snapshot_ClientName_SnapshotName_Timestamp.pptx
          let fileName = this._configService.getDropdownValues().clientName + '_' + this._configService.getDropdownValues().snapshotName + '_' + this.getCurrentDateTime() + '.pptx';
          this.downloadPPTFile(pptBlob, fileName);
          this.usageDataLog("Editable PPT Export");
          this._loaderService.hideLoader()
        },
        (error) => {
          // console.error('Error downloading the file:', error);
          // alert('An error occurred while downloading the file.');
          this.errorheaderTitle = 'Error';
          this.popUpTitle = "Error";
          //this.showPopUp = false;
          this.popUpMessage = "Some Error Occured..!";
          this.showErrorPopUp = true;
          this._loaderService.hideLoader()
        }
      ));
  }
  screengrabPPTClicked() {
    this.Loader.showLoader();
    this.captureScreenshot();

  }

  captureScreenshot() {

    this.closeDropdown();
    let paginationElement = document.getElementById("pagination-div");
    if (paginationElement) {
      paginationElement.style.visibility = "hidden";
    }
    let data = this._configService.getDropdownValues();
    this._configService.setDropdownValue('outputArray', JSON.stringify(this._configService.allPageOutputData));
    let element = document.getElementById("chart-divs");
    if (element != undefined) {
      html2canvas(element, {
        useCORS: true,
        allowTaint: true,
      }).then((canvas) => {

        let imgString = canvas.toDataURL('image/png'); //convert the canvas as image
        imgString = imgString.replace('data:image/png;base64,', '');

        return this._configService.exportPPT(imgString, "Snapshot/PreparePPT", data.selectionSummary, data).subscribe(
          (response) => {


            let datetimeFormat = this.getCurrentDateTime();
            //Snapshot_UnEditable_ClientName_SnapshotName_SnapshotType_Timestamp.pptx
            let fileName =

              'Snapshot' + '_' + 'UnEditable' + '_' +
              data.clientName +
              '_' +
              data.snapshotName + '_' +
              data.compareAcross + '_' +
              datetimeFormat +
              '.pptx';

            // Trigger file download

            this.downloadFile(response, fileName);

            this.Loader.hideLoader();
            let paginationElement = document.getElementById("pagination-div");
            if (paginationElement) {
              paginationElement.style.visibility = "visible";
            }

            this.usageDataLog("Uneditable PPT Export");


            //return response;
          }
        );
      });
    }
  }
  //Grabs the screenshot of element and converts it into base64 string

  excelexportClicked() {
    // this._configService.setDropdownValue('outputArray', JSON.stringify(this._configService.allPageOutputData));
    this._configService.setDropdownValue('outputArray', JSON.stringify(this._configService.allPageOutputDataWithoutTrend));
    this._configService.setDropdownValue('outputTrendArray', JSON.stringify(this._configService.allPageOutputData));
    this.handleExcelExportClick();
  }
  private downloadPPTFile(data: Blob, filename: string) {
    const blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation', // MIME type for PPTX
    });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;

    // Trigger download
    a.click();
    document.body.appendChild(a);
    // setTimeout(()=>{
    //   a.click();
    // },100)
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  onBaseValuesChanged(event: any) {
    this.LowBase = event.lowBase;
    this.insufficientBase = event.insufficientBase;
  }

  LoadSelection(isDefaultLoad:any) {
    this.isDefaultLoad = isDefaultLoad;
    this._configService.loadSelectionData(
      this.selected_client,
      this._configService.outputSnapshotData.snapshot_name,
      this.existingData[0]?.snapshotType,
      this.existingData[0]?.subsection,
      this.existingData[0]?.sections,
      this._configService.selectedStudy,
      COMMON_CONSTANTS_SNAPSHOT.SnapshotModuleId,
      'userDefined'
    ).subscribe((result: results) => {
      if (result.HasValidData) {
        var JsonData = JSON.parse(result.Data);
        JsonData = JsonData.filter((item: any) => item.selection_name !== "Global Default Selection");

        this.loadDefaultSavedScenarioData = JsonData.find((x:any) => x.is_default == true);
        if(this.loadDefaultSavedScenarioData != null && this.isDefaultLoad){
          this.getDefaultSelectedLoadData(this.loadDefaultSavedScenarioData,'userDefined');
        }
        //sort custom groups based on sort_id
        this.loadUserDefinedSavedScenarioData = JsonData.sort(
          (a: any, b: any) => b.sortid - a.sortid
        );
        this.isLoadSelection = true;

      }
      this._configService.setloadSelecVariable(this.isLoadSelection);

      this.Loader.hideLoader();
    });

    this._configService.loadSelectionData(
      this.selected_client,
      this._configService.outputSnapshotData.snapshot_name,
      this.existingData[0]?.snapshotType,
      this.existingData[0]?.subsection,
      this.existingData[0]?.sections,
      this._configService.selectedStudy,
      COMMON_CONSTANTS_SNAPSHOT.SnapshotModuleId,
      'sharedWithMe'
    ).subscribe((result: results) => {
      // Response is valid
      if (result.HasValidData) {
        var JsonData = JSON.parse(result.Data);
        JsonData = JsonData.filter((item: any) => item.selection_name !== "Global Default Selection");

        this.loadDefaultSavedScenarioData = JsonData.find((x:any) => x.shared_details[0]?.is_Shared_default == true);
        if(this.loadDefaultSavedScenarioData != null && this.isDefaultLoad){
           this.getDefaultSelectedLoadData(this.loadDefaultSavedScenarioData,'sharedWithMe');
        }
        //sort custom groups based on sort_id
        this.loadSharedWithMeSavedScenarioData = JsonData.sort(
          (a: any, b: any) => b.sortid - a.sortid
        );
      }

      this.Loader.hideLoader();
    });

  }

  getDefaultSelectedLoadData(DefaultSavedScenarioData:any,scenarioType:string){
    this._configService
        .getSavedScenarioData(
          DefaultSavedScenarioData.study,
          DefaultSavedScenarioData.client_name,
          DefaultSavedScenarioData.snapshotName,
          DefaultSavedScenarioData.snapshotType,
          DefaultSavedScenarioData.section,
          DefaultSavedScenarioData.subSection,
          DefaultSavedScenarioData.selection_name,
          scenarioType,
          DefaultSavedScenarioData.module_id
        )
        .subscribe((result: results) => {
          // Response is valid
          if (result.HasValidData) {
            this.bindSelectedScenario({
              selectedScenarioData: JSON.parse(result.Data),
              columnName: ''
          });
          }
          else {
            this.Loader.hideLoader();
          }
          //hide the loader
        });
    }
  


  isSaveSelectionClick: boolean = false;
  showSaveSelectionPopup = false;
  // isShareSelectionClick:boolean=false;
  saveSelection() {
    this.isSaveSelectionClick = true;
    this.showSaveSelectionPopup = false;
    this.errorheaderTitle = "SaveSelection";

  }

  SaveSelection(eventData: {
    isValidationPass: boolean;
    selectionName: string;
    isShareSelection: boolean;
    selectionType: string; //userdefined or shared with me
  }): void {
    this.isSaveSelectionClick = false;
    this.showSaveSelectionPopup = false;
    this.errorheaderTitle = "";
    if (eventData.isShareSelection) {
      this.isShareSelectionClick = true;
      //display sharing popup
      // this.bindShareSelection(
      //   eventData.selectionName,
      //   eventData.selectionType,
      //   this.currentSavedScenarioData
      // );
    } else this.bindSaveSelection(eventData);
  }

  //   LoadSelection(){
  //     this.isLoadSelection = true;
  //     this.loadUserDefinedSavedScenarioData = JSON.parse(this._configService.a.Data);
  //     this.loadSharedWithMeSavedScenarioData = JSON.parse(this._configService.a.Data);
  //  }

  ShareSelection(eventData: {
    isValidationPass: boolean;
    selectionName: string;
    isShareSelection: boolean;
    selectionType: string; //userdefined or shared with me
    is_CustomGroup: boolean;
  }): void {
    if (
      //share and if custom group is involved
      eventData.is_CustomGroup &&
      eventData.isShareSelection
    ) {
      //generte current selected obj
      this.generateSelectedScenarioObj(
        eventData.selectionType,
        eventData.selectionName
      );
      this.bindDeleteMessage({
        deleteMessage:
          eventData.selectionName +
          ' contains custom content. Are you sure you want to share the selection?',
        selectionType: 'share_customGroup',
      });

      this.isShowDialog = true;

    } else if (eventData.isShareSelection) {
      this.isShareSelectionClick = true; //to make share user popup visible
      //display sharing popup
      this.bindShareSelection(
        eventData.selectionName,
        eventData.selectionType,
        this.currentSavedScenarioData
      );
    } //else this.bindSaveSelection(eventData);
  }


  bindShareSelection(
    selectionName: string,
    selectionType: string,
    selectedScenarioObj: any
  ) {
    //get user list to share based on module,client and study
    this._usermanagementService
      .getUsersBasedonStudy(
        this.selected_client,
        this.clientDetails.clientDetails.main_study,
        this.selected_module
      )
      .subscribe((result: results) => {
        // Check if the response has valid data
        if (result.HasValidData) {
          this.shareSelectionUserList = JSON.parse(result.Data);
        }
        this.generateSelectedScenarioObj(selectionType, selectionName);

        //users with whom this load selection is shared already
        this.selectedEmailsToShare = [];
          // this.selectedLoadSelectionObj.shared_with.trim().length > 0
          //   ? this.selectedLoadSelectionObj.shared_with.split(',')
          //   : [];
    
            if (this.selectedLoadSelectionObj?.shared_with && this.selectedLoadSelectionObj.shared_with.trim().length > 0) {
              // Case 1: shared_with is a string (comma-separated)
              this.selectedEmailsToShare = this.selectedLoadSelectionObj.shared_with.split(',');
            } else if (this.selectedLoadSelectionObj?.shared_details?.length > 0) {
              // Case 2: shared_details is an array with shared_with values
              this.selectedEmailsToShare = this.selectedLoadSelectionObj.shared_details.map((detail:any) => detail.shared_with);
            }
      });

  }

  bindcurrentSavedScenarioData(eventData: {
    currentSavedScenarioData: string;
  }): void {
    this.currentSavedScenarioData = eventData.currentSavedScenarioData;
    this._configService.currentSavedScenarioData = this.currentSavedScenarioData;
  }

  generateSelectedScenarioObj(selectionType: string, selectionName: string) {
    var selectionData =
      selectionType == 'userDefined'
        ? this.loadUserDefinedSavedScenarioData
        : this.loadSharedWithMeSavedScenarioData;

    //get inputObj //only userdefined can be saved newly
    this.selectedLoadSelectionObj = _.filter(
      selectionData,
      (r) =>
        r.selection_name === selectionName &&
        r.client_name === this.selected_client &&
        r.study === this._configService.selectedStudy
      // r.module_id === this.selected_module
    )[0];
  }

  updateShowDialog(eventData: { isShowDialog: boolean }): void {
    this.isShowDialog = eventData.isShowDialog;
  }

  bindDeleteMessage(eventData: {
    deleteMessage: string;
    selectionType: string;
  }): void {
    this.deleteMessage = eventData.deleteMessage;
    this.loadSelectionType = eventData.selectionType;
  }

  handleShareSelectionPopUp(eventData: { isClose: boolean, isShared: boolean }): void {
    if (eventData.isShared) {
      // Update shared object
      this.updateSharedListAndObject(
        this.selectedLoadSelectionObj,
        this.selectedEmailsToShare,
        this.loadSharedWithMeSavedScenarioData,
        this.loadUserDefinedSavedScenarioData,
        'loadSelection'
      );
    }

    this.isShareSelectionClick = eventData.isClose;
  }

  updateSharedListAndObject(
    selectedObj: any,
    selectedEmailsToShare: string[],
    sharedWithData: any[],
    userDefinedData: any[],
    type: string
  ): void {
    //check wether the same selection is shared already then need not update the existing object
    var filteredObj = _.filter(sharedWithData, (element) => {
      if (
        element.selection_name === selectedObj.selection_name &&
        element.study === selectedObj.study &&
        element.client_name === selectedObj.client_name
      ) {
        return element;
      }
    });

    // Update shared list if the object is shared with the current user
    if (
      selectedEmailsToShare.includes(selectedObj.user_name) &&
      filteredObj.length == 0
    ) {
      sharedWithData.unshift(selectedObj);
    }

    // Update shared object
    userDefinedData = _.map(userDefinedData, (element) => {
      if (
        element.selection_name === selectedObj.selection_name &&
        element.study === selectedObj.study &&
        element.client_name === selectedObj.client_name
      ) {
        return {
          ...element,
          is_shared: true,
          shared_with: selectedEmailsToShare.toString(),
        };
      }
      return element;
    });

    //updating original objects to rebind data
    if (type == 'customGroup') {
      this.loadCustomGroupUserDefinedData = userDefinedData;
      this.loadCustomGroupSharedWithMeData = sharedWithData;
    } else if (type == 'loadSelection') {
      this.loadUserDefinedSavedScenarioData = userDefinedData;
      this.loadSharedWithMeSavedScenarioData = sharedWithData;
    } else if (type == 'customCalculation') {
      this.loadCustomCalculationUserDefinedData = userDefinedData;
      this.loadCustomCalculationSharedWithMeData = sharedWithData;
    }
  }


  onConfirmation(operation: number) {
    if (operation === 1) {
      //if confirmation is to share the selection
      if (this.loadSelectionType == 'share_customGroup') {
        this.isShowDialog = false;
        this.isShareSelectionClick = true; //to make share user popup visible
        //display sharing popup
        this.bindShareSelection(
          this.currentSavedScenarioData.selection_name,
          'userDefined',
          this.currentSavedScenarioData
        );
      } else {
        this.Loader.showLoader();
        this._configService
          .deleteSavedScenario(
            this.currentSavedScenarioData.client_name,
            this.currentSavedScenarioData.study,
            this.currentSavedScenarioData.snapshotName,
            this.currentSavedScenarioData.module_id,
            this.currentSavedScenarioData.selection_name,
            this.currentSavedScenarioData.snapshotType,
            this.currentSavedScenarioData.subSection,
            this.currentSavedScenarioData.section,
            this.loadSelectionType

          )
          .subscribe((result: results) => {
            this.showLoaderPopUp = false;

            // Response is valid
            if (result.HasValidData) {
              if (this.loadSelectionType == 'userDefined') {
                // //rebind load selection
                this.loadUserDefinedSavedScenarioData =
                  this.loadUserDefinedSavedScenarioData.filter((x: any) => {
                    return (
                      x.selection_name !==
                      this.currentSavedScenarioData.selection_name
                    );
                  });
              } else {
                this.loadSharedWithMeSavedScenarioData =
                  this.loadSharedWithMeSavedScenarioData.filter((x: any) => {
                    return (
                      x.selection_name !==
                      this.currentSavedScenarioData.selection_name
                    );
                  });
              }

              this.isShowDialog = false;
              const alertObj: AlertMessageModel = {
                header: 'Deletion info',
                message: 'Selected Scenario is deleted successfully',
                show: true,
              };
              // Show the alert popup using the alert service
              this._alertService.showAlert(alertObj);            
            } else {
              this.isShowDialog = false;
              const alertObj: AlertMessageModel = {
                header: 'Deletion info',
                message: 'Deletion Failed',
                show: true,
              };
              // Show the alert popup using the alert service
              this._alertService.showAlert(alertObj);             
            }
            this.Loader.hideLoader();
          });
      }
    }
    else {
      this.isShowDialog = false;
    }





  }

  defaultReferenceLevel: any = "None";
  DefaultSampleSize: any = "None";
  $unSubscribeSubmitData6!: Subscription;
  bindSaveSelection(eventData: {
    isValidationPass: boolean;
    selectionName: string;
    isShareSelection: boolean;
    selectionType: string;
  }) {
    if (eventData.isValidationPass) {
      // Call the function with the provided dataObject
      const is_customGroup = false;
      // this.UpdateSelectionSummary();
      this.Loader.showLoader();
      const listA: any = [];
      const listB: any = [];
      const listC: any = [];
      const listD: any = [];
      const listE: any = [];

      const dataObject = this._configService.dataObjectForSaveSelection; // previewdata
      const inputObject = this._configService.finalLeftPanelInputSelectedObject;
      const outputObject = this._configService.finalLeftPanelSubmitObject;
      this.saveSelectedSelection(
        eventData,
        inputObject,
        is_customGroup,
        outputObject
      );
    }
  }

  saveSelectedSelection(
    eventData: {
      isValidationPass: boolean;
      selectionName: string;
      isShareSelection: boolean;
    },
    inputObject: any,
    is_customGroup: boolean,
    outputObject: any
  ) {
    let finalObject = {
      module_id: COMMON_CONSTANTS_SNAPSHOT.SnapshotModuleId,
      selection_name: eventData.selectionName,
      client_name: this.clientDetails.clientDetails.client_code,
      study: this._configService.widgetConfigDetails.study,
      snapshotName: this.clientDetails.clientDetails.study,
      snapshotType: this._configService.widgetConfigDetails.snapshotType,
      leftpanel_input_data: JSON.stringify(inputObject),
      output_selection_data: JSON.stringify(outputObject),
      selection_summary: this._configService.selectionSummaryText,
      is_active: true,
      is_shared: false,
      modified_by: '',
      shared_with: '',
      is_CustomGroup: is_customGroup
    }
    this.$unSubscribeSubmitData6 = this._configService
      .saveSelectionData(
        COMMON_CONSTANTS_SNAPSHOT.SnapshotModuleId,
        eventData.selectionName,
        this.clientDetails.clientDetails.client_code,
        this._configService.widgetConfigDetails.study,// contains study 
        this.clientDetails.clientDetails.study,//this contains snapshot name 
        this._configService.widgetConfigDetails.snapshotType,
        this._configService.widgetConfigDetails.section,
        this._configService.widgetConfigDetails.subSection,
        JSON.stringify(inputObject),
        JSON.stringify(outputObject),
        this._configService.selectionSummaryText,
        true,
        false,
        '',
        '',
        JSON.stringify(this._configService.entryPointData),
        is_customGroup
      )
      .subscribe((result: results) => {
        // Response is valid
        if (result.HasValidData) {
          let JsonData = JSON.parse(result.Data);
          if (JsonData == 'Record already exists') {
            this.showErrorPopUp = true;
            this.popUpTitle = "Alert";
            this.popUpMessage = "Record already exists";
            this.buttonText = "Ok";
            this.isSaveSelectionClick = false;
          } else if (JsonData == 'Saved Successfully') {
            this.showErrorPopUp = true;
            this.popUpTitle = "Alert";
            this.popUpMessage = "Saved Successfully.";
            this.buttonText = "Ok";
            this.isSaveSelectionClick = false;
          }
        }
        //hide the loader
        this.Loader.hideLoader();

        // this.usageDataLog(Feature.SaveQuery);
      });
  }


  bindSelectedScenario(eventData: {
    selectedScenarioData: any;
    columnName: string;
  }) {
    this.selectedScenarioData = eventData.selectedScenarioData;
    this.isSavedScenarioSelected = true;
    this.bindSavedSelectionDetails();
    //bind leftpanel data
    this.dataArray = JSON.parse(
      this.selectedScenarioData[0].entry_point_selection_data
    );
  }

  bindSavedSelectionDetails() {
    this.selectionSummary = this.selectedScenarioData[0].selection_summary;
    

    var leftpanel_input_data = JSON.parse(
      this.selectedScenarioData[0].leftpanel_input_data
    );
     this._configService.saveSelectionLoad=true;

     this.output_data = JSON.parse(
      this.selectedScenarioData[0].output_selection_data
    );
    // let item = {
    //   isSelected : false,
    //   key: this.output_data.significance,
    //   value:true
    // }
  //   if(this.isSavedScenarioSelected){
  //   this.significanceSelected1(item,'');
  // }

   
  }

  handleSavePopUP(eventData: { isClose: boolean }): void {
    this.isSaveSelectionClick = eventData.isClose;
  }

  additionalCheck(event:any){
    this.additionalCheckList = event;
  }

  OnSettingsSel(item: any) {
    switch (item) {
      case this.settingOptionList.SnapshotViews:
        window.open('https://www.figma.com/proto/7fV2UmWwIX7XJPGLDPoyk3/Explorer--Snapshot-Visuals?page-id=0%3A1&node-id=95-4612&viewport=3126%2C1977%2C0.23&t=HYEZhoeaEEp2zyIq-8&scaling=contain&content-scaling=fixed&starting-point-node-id=95%3A4612&hide-ui=1', '_blank');
        break;
    }
  }

  ngOnDestroy(): void {
    // Unsubscribe to prevent memory leaks and unnecessary reloads
    this.subscriptions.unsubscribe();
  }


}
